'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Filters = function () {
    function Filters() {
        _classCallCheck(this, Filters);

        /**
         * General settings
         */

        this.filterUrlPrefix = 'filters-'; // Prefisso che serve per riconoscere i filtri nel'url query

        this.namespace = SlamJam.filterSettings.namespace ? SlamJam.filterSettings.namespace : 'customFilter'; // Serve per avere degli eventi ad-hoc per i filtri
        this.perPage = parseInt(SlamJam.filterSettings.perPage); // Indica quanti prodotti mostrare per pagina
        this.filterMaxPages = parseInt(SlamJam.filterSettings.filterMaxPages); // Indica il numero totale di pagine della collection/search
        this.tagsMaxPages = parseInt(SlamJam.filterSettings.tagsMaxPages); // Indica il numero totale di pagine per ottonere i filtri

        /**
         * Variables
         */

        this.initialFiltersTag = []; // Tags totali dei prodotti della collection/search
        this.products = []; // Prodotti totali della collection/search
        this.pages = []; // Array contentente le pagine con gli oggetti dei prodotti della collection/search
        this.currentPage = 1; // Indica il numero dell'ultima pagina di prodotti caricata in frontend e può prendere il valore ?page=n dell'url nelle collection
        this.pagination = 1; // indica il numero di pagina di Shopify
        this.sorting = false; // Indica il sort attuale
        this.onInit = true; // Indica se l'init è concluso o meno
        this.filteredProducts = []; // Array contentente tutti i prodotti attualmente visibili a frontend
        this.pid = false; // Indica l'id dell'ultimo prodotto su cui si è cliccato, così da ritornare allo stesso prodotto in caso di reload
        this.lastProductPrinted = 0; // Indica l'indice dell'ultimo prodotto stampato a video

        this.clothingsizeType = 'size-clothing';
        this.shoesizeType = 'size-footwear';
        this.accessorysizeType = 'size-accessories';

        // Identifica il primo filtro selezionato dall'utente. Il primo filtro selezionato è quello su cui è possibile fare operazioni di multi-choice anche se non possibili, quindi avrà sempre tutte le checkbox cliccabili.
        // Es: se si seleziona 'nero' tra i filtri 'colore', senza una logica particolare, l'utente non potrà filtrare per un altro colore, in quanto solitamente un prodotto ha una sola tipologia di colore.
        this.firstFilterType = false;

        // Identifica il filtro corrente selezionato e visualizzato dall'utente
        this.currentFilterType = false;

        // Esclusiva SJ: Indica la stringa inserita dall'utente nel momento in cui ricerca un brand dentro la dropdown e il suo selettore
        this.searchBrand = '';
        this.searchBrandSelector = '.filter-search';

        // Esclusiva SJ: il filtro type (category) in SJ deve essere organizzato in livelli, considerando micro e macro category dei prodotti e non solo micro category
        this.filtersCategoryHierarchical = {};

        /**
         * Views
         */

        this.tagsView = SlamJam.tagsView ? SlamJam.tagsView : 'ajax-tags'; // serve per costruire l'array dei tag
        this.productsView = SlamJam.productsView ? SlamJam.productsView : 'ajax-products'; // serve per costruire l'array dei prodotti

        /**
         * Filters
         */

        this.initialFilters = SlamJam.filterSettings.filters;
        this.filters = [];

        this.url = SlamJam.filterSettings.isSearch ? '/search' : SlamJam.filterSettings.url;

        /**
         * Search
         */

        this.q = SlamJam.filterSettings.q; // query della search
        this.productType = 'product';
        this.articleType = 'article';
        this.articlesView = SlamJam.articlesView ? SlamJam.articlesView : 'ajax-articles'; // serve per costruire l'array degli articoli
        this.activeClass = 'active';
        this.articlePages = [];
        this.articles = [];

        this.showProductsSelector = this.showProductsSelector ? this.showProductsSelector : '.search-show-products';
        this.showArticlesSelector = this.showArticlesSelector ? this.showArticlesSelector : '.search-show-articles';
        this.articlesListingSelector = this.articlesListingSelector ? this.articlesListingSelector : '#shop-articles';
        this.articlesListingContainerSelector = this.articlesListingContainerSelector ? this.articlesListingContainerSelector : '.collection-template--articles';
        this.productsListingContainerSelector = this.productsListingContainerSelector ? this.productsListingContainerSelector : '.collection-template--products';

        /**
         * Size mapping (Esclusiva SJ)
         */

        //N.B il size mapping è stato pensato per funzionare solamente per la taglie calzature
        this.sizeMapping = [];
        // vado a pulire il sizemapping preservando newlines, etc
        SlamJam.filterSettings.sizeMapping = SlamJam.filterSettings.sizeMapping.replace(/\\n/g, "\\n");
        // remove non-printable and other non-valid JSON chars
        SlamJam.filterSettings.sizeMapping = SlamJam.filterSettings.sizeMapping.replace(/[\u0000-\u0019]+/g, "");
        var sizemappingCleanedUp = JSON.parse(SlamJam.filterSettings.sizeMapping);
        this.sizeMappingMetafield = sizemappingCleanedUp;

        this.sizeMappingOptions = this.sizeMappingOptions ? this.sizeMappingOptions : [{ 'label': SlamJam.filterSettings.translations.shoeSizeEu, 'value': 'eur' }, { 'label': SlamJam.filterSettings.translations.shoeSizeUs, 'value': 'us' }, { 'label': SlamJam.filterSettings.translations.shoeSizeUk, 'value': 'uk' }];

        this.selectedSizeMapping = this.sizeMappingOptions[1].value;
        this.sizeMappingSelectSelector = this.sizeMappingSelectSelector ? this.sizeMappingSelectSelector : '#size-mapping';
        this.sizeMappingFakeSelectSelector = this.sizeMappingFakeSelectSelector ? this.sizeMappingFakeSelectSelector : '.size-mapping-fake';
        this.sizeMappingFakeSelectSelectorTrigger = this.sizeMappingFakeSelectSelectorTrigger ? this.sizeMappingFakeSelectSelectorTrigger : '.size-mapping-fake__title';
        this.sizeMappingFakeOptionSelector = this.sizeMappingFakeOptionSelector ? this.sizeMappingFakeOptionSelector : '.size-mapping-fake__option';
        this.sizeMappingSelectOpenClass = this.sizeMappingSelectOpenClass ? this.sizeMappingSelectOpenClass : 'size-mapping-open';

        // Indica il simbolo da utilizzare per fare lo split sulle taglie calzatura, le quali contengono anche la scala taglia di riferimento.
        // Inizialmente avevo usato '-', ma l'ho modificato perchè ci sono taglie con '-' e questo dava problemi allo split
        this.shoeSizeSeparator = '$';

        /**
         * Common HTML selectors
         */

        this.productsListingSelector = this.productsListingSelector ? this.productsListingSelector : '#shop-products';
        this.loadMoreSelector = this.loadMoreSelector ? this.loadMoreSelector : '.load-more';
        this.paginationSelector = this.paginationSelector ? this.paginationSelector : '.pagination .paginate';
        this.loaderSelector = this.loaderSelector ? this.loaderSelector : '.loading-wrapper';
        this.sortingSelector = this.sortBySelector ? this.sortBySelector : '.sorting';
        this.sortBySelector = this.sortBySelector ? this.sortBySelector : '.sort-by';
        this.totalProductsSelector = this.totalProductsSelector ? this.totalProductsSelector : '.filter-desktop__container .total-products'; // Selettore per il contatore dei prodotti trovati filtrando
        this.totalProductsSelectorMobile = this.totalProductsSelectorMobile ? this.totalProductsSelectorMobile : '.filter-mobile__container .total-products'; // Selettore per il contatore dei prodotti trovati filtrando

        this.productCardSelector = this.productCardSelector ? this.productCardSelector : '.product-card';

        // selettore del div dei filtri
        this.filterWrappers = this.filterWrappers ? this.filterWrappers : '.filter-desktop__container .shop-filters';
        this.filterWrappersMobile = this.filterWrappersMobile ? this.filterWrappersMobile : '.filter-mobile__container .shop-filters';

        // selettore del title di un filtro
        this.filterTypeSelector = '.filter-type';
        this.filterTypeTitleSelector = '.filter-type__title';

        // selettore di un singolo filtro
        this.filterLinkSelector = this.filterLinkSelector ? this.filterLinkSelector : '.filter-option';

        // selettore in cui mostrare i filtri attualmente in uso
        this.currentFiltersSelector = this.currentFiltersSelector ? this.currentFiltersSelector : '.filter-desktop__container .current-filters';
        this.currentFilterSelectorMobile = this.currentFilterSelectorMobile ? this.currentFilterSelectorMobile : '.filter-mobile__container .current-filters';

        // selettore per il reset dei filtri
        this.clearFiltersSelector = this.clearFiltersSelector ? this.clearFiltersSelector : '#clear-filters';

        // indica le schiere taglie scritte nel customize. le schiere taglie vengono utilizzate per ordinare correttamente i filtri a frontend
        this.sizesRangeClothing = SlamJam.filterSettings.sizesRangeClothing;
        this.sizesRangeShoe = SlamJam.filterSettings.sizesRangeShoe;
        this.sizesRangeAccessory = SlamJam.filterSettings.sizesRangeAccessory;
        this.counter = '.collection-template__counter';

        /**
         * Utilities
         */

        Array.prototype.unique = function () {
            var a = this.concat();

            for (var i = 0; i < a.length; i++) {
                for (var j = i + 1; j < a.length; j++) {
                    if (a[i] === a[j]) a.splice(j--, 1);
                }
            }

            return a;
        };

        this.handleize = function (str) {
            if (str) {
                str = str.toLowerCase();

                var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];

                // For the old browsers
                for (var i = 0; i < toReplace.length; ++i) {
                    str = str.replace(toReplace[i], "");
                }

                // str = str.replace(/\W+/g, "-");

                str = str.replace('/', "--");
                str = str.replace(/\W/g, "-");

                if (str.charAt(str.length - 1) == "-") {
                    str = str.replace(/-+\z/, "");
                }

                if (str.charAt(0) == "-") {
                    str = str.replace(/\A-+/, "");
                }

                return str;
            }
        };

        this.sortObjKeysAlphabetically = function (object) {
            if (!object) {
                return object;
            }

            var isArray = object instanceof Array;
            var sortedObj = {};

            if (isArray) {
                sortedObj = object.sort();
            } else {
                var keys = Object.keys(object);

                keys.sort(function (key1, key2) {
                    if (key1.toLowerCase() < key2.toLowerCase()) return -1;
                    if (key1.toLowerCase() > key2.toLowerCase()) return 1;

                    return 0;
                });

                for (var index in keys) {
                    var key = keys[index];

                    if (object[key]) {
                        sortedObj[key] = this.sortObjKeysAlphabetically(object[key]);
                    }
                }
            }

            return sortedObj;
        };

        this.findInObjectValuesArray = function (object, value) {
            var found = false;

            Object.keys(object).forEach(function (objectKey) {
                for (var i = 0; i < object[objectKey].length; i++) {
                    if (object[objectKey][i] == value) {
                        found = object[objectKey][i];
                        break;
                    }
                }
            });

            return found;
        };

        this.initEventHandlers();
        this.customInitEventHandlers();
        this.dispatchEvent('onInit');
        this.init();
    }

    _createClass(Filters, [{
        key: 'init',
        value: function init() {
            var $self = this;

            var promiseTags = this.getTags();
            var promiseProducts = this.getProducts();
            var promiseArticles = SlamJam.filterSettings.isSearch ? this.getArticles() : [];

            // Quando ho sia tags che prodotti, inizializzo i filtri
            Promise.all([promiseTags, promiseProducts, promiseArticles]).then(function () {
                $self.sortProducts();
                $self.initFilters();
            });

            // Dico al browser di evitare di mantenermi lo scroll totale dopo il back
            if (history.scrollRestoration) {
                history.scrollRestoration = 'manual';
            }
        }
    }, {
        key: 'dispatchEvent',
        value: function dispatchEvent(event, data) {
            data ? window.dispatchEvent(new CustomEvent(this.namespace + '-' + event, {
                detail: data
            })) : window.dispatchEvent(new CustomEvent(this.namespace + '-' + event));
        }
    }, {
        key: 'formatTags',
        value: function formatTags() {
            var _this = this;

            var filterTags = [];
            var formatFilterTags = {};

            for (var i = 0; i < this.initialFiltersTag.length; i++) {
                filterTags = filterTags.concat(this.initialFiltersTag[i]);
            }

            filterTags = filterTags.unique();

            var _loop = function _loop(_i) {
                var splittedFilterTag = filterTags[_i].split(/_(.*)/s);

                // Se la tipologia del tag è tra quelle incluse in quelle da mostrare e non è un tag con cui costruiamo il sistema di filtraggio delle collection
                if (_this.initialFilters.find(function (initialFilter) {
                    return initialFilter.type === splittedFilterTag[0];
                }) || splittedFilterTag[0] == SlamJam.filterSettings.categoryFilter.microCategory || splittedFilterTag[0] == SlamJam.filterSettings.categoryFilter.macroCategory || splittedFilterTag[0] == SlamJam.filterSettings.categoryFilter.department) {
                    if (splittedFilterTag[1] != 'unisex' && splittedFilterTag[1] != 'kids') {
                        if (formatFilterTags[splittedFilterTag[0]]) {
                            formatFilterTags[splittedFilterTag[0]].push({
                                type: splittedFilterTag[0], // tipologia del tag
                                tag: splittedFilterTag[1], // valore del tag
                                disabled: false // indica se il filtro a frontend deve essere disabled
                            });
                        } else {
                            formatFilterTags[splittedFilterTag[0]] = [];
                            formatFilterTags[splittedFilterTag[0]].push({
                                type: splittedFilterTag[0],
                                tag: splittedFilterTag[1],
                                disabled: false
                            });
                        }
                    }
                }
            };

            for (var _i = 0; _i < filterTags.length; _i++) {
                _loop(_i);
            };

            this.initialFiltersTag = formatFilterTags;

            // Custom SJ (serve solamente con visualizzare graficamente il filtro category)
            this.initialFiltersTag['category'] = [];
        }
    }, {
        key: 'getTags',
        value: function getTags() {
            var $self = this;

            return new Promise(function (resolve) {
                var callsCount = $self.tagsMaxPages;
                var promises = [];

                var ajaxCall = function ajaxCall(url) {
                    return new Promise(function (resolve) {
                        $.get(url).done(function (data) {
                            var COMMENT_PSEUDO_COMMENT_OR_LT_BANG = new RegExp('<!--[\\s\\S]*?(?:-->)?' + '<!---+>?' // A comment with no body
                            + '|<!(?![dD][oO][cC][tT][yY][pP][eE]|\\[CDATA\\[)[^>]*>?' + '|<[?][^>]*>?', // A pseudo-comment
                            'g');

                            data = data.replace(COMMENT_PSEUDO_COMMENT_OR_LT_BANG, '');
                            data = JSON.parse(data);

                            for (var j = 0; j < data.tags.length; j++) {
                                $self.initialFiltersTag.push(data.tags[j]);
                            }

                            resolve(data);
                        }).fail(function (data) {
                            totalPromiseError.push({
                                response: data
                            });
                            resolve(data);
                        });
                    });
                };

                for (var i = 0; i < callsCount; i++) {
                    var url = location.origin + $self.url + '?view=' + $self.tagsView + '&page=' + (i + 1) + ($self.q ? '&q=' + $self.q : '') + ($self.productType ? '&type=' + $self.productType : '');
                    promises.push(ajaxCall(url));
                };

                Promise.all(promises).then(function () {
                    $self.formatTags();
                    $self.dispatchEvent('onTagsFetched');
                    resolve();
                });
            });
        }
    }, {
        key: 'getProducts',
        value: function getProducts() {
            var $self = this;

            return new Promise(function (resolve) {
                var callsCount = $self.filterMaxPages;
                var promises = [];

                var ajaxCall = function ajaxCall(url) {

                    return new Promise(function (resolve) {
                        $.get(url).done(function (data) {
                            var COMMENT_PSEUDO_COMMENT_OR_LT_BANG = new RegExp('<!--[\\s\\S]*?(?:-->)?' + '<!---+>?' // A comment with no body
                            + '|<!(?![dD][oO][cC][tT][yY][pP][eE]|\\[CDATA\\[)[^>]*>?' + '|<[?][^>]*>?', // A pseudo-comment
                            'g');

                            data = data.replace(COMMENT_PSEUDO_COMMENT_OR_LT_BANG, '');
                            data = JSON.parse(data);

                            if (data.collectionSortBy) {
                                $self.sorting = data.collectionSortBy;
                            }

                            if (data.products.length > 0) {
                                var products = data.products;

                                // Trasformo filterData in un array multidimensionale di filtri per avere un'alberatura di corretta di department, macro category e micro category

                                var _loop2 = function _loop2(j) {
                                    var filterDataArray = [];

                                    // Incude gestione esclusiva SJ per il filtro 'category' che può essere rimossa per altri progetti
                                    if (products[j].filterData) {
                                        var department = false;
                                        var macroCategory = false;
                                        var microCategory = false;

                                        products[j].filterData.map(function (filterTag, index) {
                                            var splittedFilterTag = filterTag.split(/_(.*)/s);

                                            if (filterDataArray[splittedFilterTag[0]]) {
                                                filterDataArray[splittedFilterTag[0]].push(splittedFilterTag[1]);
                                            } else {
                                                filterDataArray[splittedFilterTag[0]] = [];
                                                filterDataArray[splittedFilterTag[0]].push(splittedFilterTag[1]);
                                            }

                                            if (splittedFilterTag[0] == SlamJam.filterSettings.categoryFilter.microCategory) {
                                                microCategory = splittedFilterTag[1];
                                            } else if (splittedFilterTag[0] == SlamJam.filterSettings.categoryFilter.macroCategory) {
                                                macroCategory = splittedFilterTag[1];
                                            } else if (splittedFilterTag[0] == SlamJam.filterSettings.categoryFilter.department) {
                                                department = splittedFilterTag[1];
                                            }
                                        });

                                        // Costruisco l'array dei filtri type con tre livelli
                                        if (macroCategory && microCategory && department) {
                                            if (!$self.filtersCategoryHierarchical[department]) {
                                                $self.filtersCategoryHierarchical[department] = {};
                                                $self.filtersCategoryHierarchical[department][macroCategory] = [];
                                            }

                                            if (!$self.filtersCategoryHierarchical[department][macroCategory]) {
                                                $self.filtersCategoryHierarchical[department][macroCategory] = [];
                                                $self.filtersCategoryHierarchical[department][macroCategory].push(microCategory);
                                            } else if ($self.filtersCategoryHierarchical[department][macroCategory] && !$self.filtersCategoryHierarchical[department][macroCategory].includes(microCategory)) {
                                                $self.filtersCategoryHierarchical[department][macroCategory].push(microCategory);
                                            }
                                        }
                                    }

                                    products[j].filterData = filterDataArray;
                                };

                                for (var j = 0; j < data.products.length; j++) {
                                    _loop2(j);
                                }

                                $self.pages[data.page] = products;
                            }

                            resolve(data);
                        }).fail(function (data) {
                            resolve(data);
                        });
                    });
                };

                for (var i = 0; i < callsCount; i++) {
                    var url = location.origin + $self.url + '?view=' + $self.productsView + '&page=' + (i + 1) + ($self.q ? '&q=' + $self.q + '*' + '&options[prefix]=last' : '') + ($self.productType ? '&type=' + $self.productType : '');
                    promises.push(ajaxCall(url));
                };

                Promise.all(promises).then(function () {
                    // Dopo aver fatto tutte le chiamate, riempio l'array contenente tutti i prodotti della collection/search. Le pagine partono da 1
                    var position = 0;

                    for (var _i2 = 1; _i2 < $self.pages.length; _i2++) {
                        var products = [];

                        for (var j = 0; j < $self.pages[_i2].length; j++) {
                            var product = $self.pages[_i2][j];
                            product.position = position++; // serve per il sorting trending (quello iniziale)

                            products.push(product);
                        }

                        $self.products = $self.products.concat(products);
                    }

                    $self.dispatchEvent('onProductsFetched');
                    resolve();
                });
            });
        }
    }, {
        key: 'getArticles',
        value: function getArticles() {
            var $self = this;

            return new Promise(function (resolve) {
                var promises = [];
                var callsCount = $self.filterMaxPages;

                var ajaxCall = function ajaxCall(url) {
                    return new Promise(function (resolve) {
                        $.get(url).done(function (data) {
                            var COMMENT_PSEUDO_COMMENT_OR_LT_BANG = new RegExp('<!--[\\s\\S]*?(?:-->)?' + '<!---+>?' // A comment with no body
                            + '|<!(?![dD][oO][cC][tT][yY][pP][eE]|\\[CDATA\\[)[^>]*>?' + '|<[?][^>]*>?', // A pseudo-comment
                            'g');

                            data = data.replace(COMMENT_PSEUDO_COMMENT_OR_LT_BANG, '');
                            data = JSON.parse(data);

                            if (data.articles && data.articles.length > 0) {
                                $self.articlePages[data.page] = data.articles;
                            }

                            resolve(data);
                        }).fail(function (data) {
                            totalPromiseError.push({
                                response: data
                            });
                            resolve(data);
                        });
                    });
                };

                for (var i = 0; i < callsCount; i++) {
                    var url = location.origin + $self.url + '?view=' + $self.articlesView + '&page=' + (i + 1) + ($self.q ? '&q=' + $self.q + '&options[prefix]=last' : '') + ($self.articleType ? '&type=' + $self.articleType : '');

                    promises.push(ajaxCall(url));
                };

                Promise.all(promises).then(function () {
                    // Dopo aver fatto tutte le chiamate, creo l'array con tutti gli articoli

                    for (var _i3 = 0; _i3 < $self.articlePages.length; _i3++) {
                        if ($self.articlePages[_i3]) {
                            for (var j = 0; j < $self.articlePages[_i3].length; j++) {
                                // nascondo gli hidden cam
                                if (!$self.articlePages[_i3][j].url.includes('hidden-cam')) {
                                    $self.articles.push($self.articlePages[_i3][j]);
                                }
                            }
                        }
                    }

                    resolve();
                });
            });
        }

        /**
         * Filters logic
         */

    }, {
        key: 'initFilters',
        value: function initFilters() {
            var $self = this;

            // Controllo se trovo nel localStorage il primo filtro selezionato, che ci servirà per ricreare correttamente l'html dei filtri
            if (localStorage.getItem('filter-first')) {
                if (!localStorage.getItem('filter-first') || localStorage.getItem('filter-first') == 'false') {
                    this.firstFilterType = false;
                } else {
                    this.firstFilterType = localStorage.getItem('filter-first');
                }
            }

            // Inizializzo l'array dei filtri in cui mantengo i filtri attualmente selezionati
            $self.initialFilters.forEach(function (filter, index) {
                if (filter.type) {
                    $self.filters[filter.type] = [];

                    // Controllo se ci sono filtri della tipologia corrente nell'url
                    if ($self.getUrlParameter($self.filterUrlPrefix + filter.type)) {
                        var urlParams = $self.getUrlParameter($self.filterUrlPrefix + filter.type).split(',');

                        // Aggiorno l'array dei fltri con i filtri nell'url
                        for (var j = 0; j < urlParams.length; j++) {
                            $self.updateFilterObject(filter.type, urlParams[j]);
                        }
                    }
                }
            });

            // Controllo se ci sono sorting nell'url
            if (this.getUrlParameter('custom-sort-by')) {
                // Ordino i prodotti
                this.sorting = this.getUrlParameter('custom-sort-by');
                this.sortProducts();
            } else {
                // eventuale set di un sorting iniziale
                this.sorting = '';
            }

            // Controllo se c'è il paramentre se_tab che mi indica che l'utente ha cliccato sul more degli articoli nella search preview
            if (this.getUrlParameter('se_tab')) {
                this.handleHiglight('articles');
            }

            if (parseInt(this.getUrlParameter('page'))) this.currentPage = parseInt(this.getUrlParameter('page'));
            if (parseInt(this.getUrlParameter('pagination'))) this.pagination = parseInt(this.getUrlParameter('pagination'));

            this.sortFilters();

            this.executeFilters();

            this.onInit = false;

            this.dispatchEvent('onInitEnded');
        }
    }, {
        key: 'executeFilters',
        value: function executeFilters() {
            var $self = this;

            var productToRemove = [];

            this.dispatchEvent('onFiltersUpdating');

            this.fetchPages();

            this.filteredProducts.forEach(function (product, productIndex) {
                var countProductFilter = 0;
                var countFilters = 0;

                Object.keys($self.filters).map(function (filterType) {
                    // Controllo che il prodotto che sto analizzando abbia tutti i tag selezionati dall'utente
                    if ($self.checkFilter(product, filterType)) {
                        countProductFilter++;
                    }

                    // Conto quante tipologie di filtri ci sono
                    countFilters++;
                });

                // Se per ogni tipologia di tag, il prodotto ha tutti i tag selezionati dal cliente (o nessuno perchè non ci sono tag attivi), lo mostro, altrimenti segno l'id del prodotto nei prodotti che poi andranno rimossi a frontend
                if (countProductFilter != countFilters) {
                    // Segno in un array l'indice del prodotto da eliminare
                    productToRemove.push(productIndex);
                }
            });

            // Rimuovo i prodotti da eliminare da quelli visibili a frontend
            this.filteredProducts = $self.filteredProducts.filter(function (product, index) {
                return !productToRemove.includes(index);
            });

            // Gestione grafica del disabled dei filtri
            this.disableFilters();

            // Faccio lo scroll top ad ogni modifica di filtro.
            window.scrollTo(0, 0);
            document.getElementById('PageContainer').scrollTop = 0;

            this.dispatchEvent('onFiltersUpdated', {
                product: this.filteredProducts,
                filters: this.filters,
                sorting: this.sorting
            });
        }
    }, {
        key: 'checkFilter',
        value: function checkFilter(product, type) {
            var _this2 = this;

            var $self = this;

            // Se per la tipologia di tag non ci sono tag attivi, il prodotto per quella tipologia di tag, si può considerare visibile.
            if (!this.filters[type].length > 0) {
                return true;
            }

            if (type != this.shoesizeType) {
                for (var i = 0; i < this.filters[type].length; i++) {
                    // Per fare il check se un prodotto deve essere visibile o meno a seconda del tag selezionato, utilizzo la funzione handleize.
                    // Questo ci permette di mantenere il valore corretto del tag e anche di evitare i problemi dovuti a controlli su tag con valori contenenti spazi o caratteri speciali
                    var formattedFilterData = product.filterData[type] ? product.filterData[type].map(function (tag) {
                        return $self.handleize(tag);
                    }) : null;

                    // Se all'interno dei tag del prodotto trovo il filtro selezionato, allora il prodotto è visibile
                    if (formattedFilterData && formattedFilterData.includes($self.handleize($self.filters[type][i]))) {
                        return true;
                    }
                }
            } else {
                // Per il size mapping occorre fare un ragionamento diverso rispetto a tutti gli altri filtri.
                // Un prodotto è visibile se le taglie calzatura selezionate dall'utente nei filtri sono presenti come corrispondenze nel suo size mapping.
                // Es: un cliente seleziona 4US. Devo capire se nel size mapping del prodotto esiste una corrispondenza con 4US, che potrebbe essere 3.5UK, 35 EUR etc...

                for (var _i4 = 0; _i4 < this.filters[type].length; _i4++) {
                    if (product.filterData[type] && product.sizeMappingId) {
                        var _ret3 = function () {
                            // Trovo il size mapping del prodotto all'interno del metafield
                            var currentSizeMapping = _this2.sizeMappingMetafield.find(function (sizeMapping) {
                                return sizeMapping.id == parseInt(product.sizeMappingId);
                            });
                            var splittedTag = _this2.filters[type][_i4].split($self.shoeSizeSeparator);
                            if (currentSizeMapping && splittedTag[0]) {
                                // Trovo le riga nel size mapping relativa alla taglia che sto analizzando

                                var sizeMappingRows = currentSizeMapping.size.filter(function (size) {
                                    var property = size[splittedTag[1]];
                                    if (property !== undefined) {
                                        return property.toString().toLowerCase() === splittedTag[0].toLowerCase();
                                    }
                                    return false;
                                });

                                if (sizeMappingRows.length > 0) {
                                    // Analizzo la riga del mapping per capire se ho una corrispondenza
                                    for (var j = 0; j < sizeMappingRows.length; j++) {
                                        var _iteratorNormalCompletion = true;
                                        var _didIteratorError = false;
                                        var _iteratorError = undefined;

                                        try {
                                            for (var _iterator = Object.entries(sizeMappingRows[j])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                                var _step$value = _slicedToArray(_step.value, 2),
                                                    key = _step$value[0],
                                                    value = _step$value[1];

                                                // Praticamente, un prodotto è visibile se:
                                                // 1) la scala taglia che sto analizzando (key) è uguale a quella del filtro e trovo nei tag del prodotto il valore della taglia (value);
                                                // 2) la scala taglia che sto analizzando (key) è uguale al defaultSizeScale del prodotto e trovo nei tag del prodotto il valore della taglia (value);

                                                if (key == splittedTag[1] && product.filterData[type].includes(typeof value === 'string' ? value.toLowerCase() : value) || key == product.defaultSizeScale && product.filterData[type].includes(typeof value === 'string' ? value.toLowerCase() : value)) {
                                                    return {
                                                        v: true
                                                    };
                                                }
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally {
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator.return) {
                                                    _iterator.return();
                                                }
                                            } finally {
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            // Nel caso in cui un prodotto non abbia il sizeMappingId, ma solo la scala taglia di riferimento, allora devo comunque mostrare il prodotto
                            // se il cliente ha selezionato un filtro di una taglia footwear che il prodotto ha, considerando anche il defaultSizeScale.
                            // Es: un cliente seleziona 4US, se analizzando tutti i prodotti trovo un prodotto che ha tag 'size-footwear_4' e il defaultSizeScale 'US' allora il prodotto deve essere mostrato
                            // anche se non ha il size mapping.
                        }();

                        if ((typeof _ret3 === 'undefined' ? 'undefined' : _typeof(_ret3)) === "object") return _ret3.v;
                    } else if (product.defaultSizeScale && product.filterData[this.shoesizeType]) {
                        var defaultSizeScale = product.defaultSizeScale.toLowerCase();

                        for (var _i5 = 0; _i5 < this.filters[type].length; _i5++) {
                            var _formattedFilterData = product.filterData[type] ? product.filterData[type].map(function (tag) {
                                return $self.handleize(tag);
                            }) : null;
                            var splittedTag = $self.filters[type][_i5].split(this.shoeSizeSeparator);

                            // Se all'interno dei tag del prodotto trovo il filtro selezionato, allora il prodotto è visibile
                            if (_formattedFilterData && defaultSizeScale == splittedTag[1] && _formattedFilterData.includes($self.handleize(splittedTag[0]))) {
                                return true;
                            }
                        }
                    }
                }
            }

            return false;
        }

        // Permette di disabilitare al frontend tutti i filtri che portano ad un 'not found' se applicati.
        // Si potrebbe ottimizzare leggermente.

    }, {
        key: 'disableFilters',
        value: function disableFilters() {
            var $self = this;

            if (this.countActiveFilters() > 0) {
                if ($self.countActiveFilters() == 1) {
                    // Se ho un solo filtro attivo, la tipologia di questo filtro diventa quella iniziale, usata per definire i disabled
                    Object.keys(this.filters).map(function (filterType) {
                        if ($self.filters[filterType].length > 0) {
                            $self.firstFilterType = filterType;
                        }
                    });
                }

                // Metto tutti i filtri a disabled = false, tranne quelli del filtro iniziale che sono sempre tutti selezionabili
                Object.keys(this.initialFiltersTag).map(function (initialFilterType) {

                    for (var i = 0; i < $self.initialFiltersTag[initialFilterType].length; i++) {
                        if (initialFilterType != $self.firstFilterType) {
                            $self.initialFiltersTag[initialFilterType][i].disabled = true;
                        } else {
                            $self.initialFiltersTag[initialFilterType][i].disabled = false;
                        }
                    }
                });

                // Metto tutti i filtri footwear a disabled = false, tranne quando il filtro iniziale è proprio quello per i footwear
                Object.keys($self.sizeMapping).map(function (key) {
                    for (var i = 0; i < $self.sizeMapping[key].length; i++) {
                        if ($self.sizeMapping[key][i].disabled != undefined) {
                            if ($self.shoesizeType != $self.firstFilterType) {
                                $self.sizeMapping[key][i].disabled = true;
                            } else {
                                $self.sizeMapping[key][i].disabled = false;
                            }
                        }
                    }
                });

                // Il check per capire se uno dei filtri iniziali è disabled deve partire sempre controllando i tag di tutti i prodotti e non solo di quelli filtered, perchè in quelli filtered già sono stati applicati i filtri
                // La logica applicata è simile quella del filtraggio (checkFilter), ma su tutti i prodotti.
                $self.products.map(function (product) {
                    var testFilters = [];

                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        var _loop3 = function _loop3() {
                            var _step2$value = _slicedToArray(_step2.value, 2),
                                initialFilterType = _step2$value[0],
                                initialFilterTypeArray = _step2$value[1];

                            var filterTypeTags = initialFilterTypeArray.map(function (initialFilterTag) {
                                return $self.handleize(initialFilterTag.tag);
                            });

                            // Prendo i prodotti che soddisfano le condizioni dei filtri selezionati dal cliente
                            Object.keys($self.filters).map(function (filterKey) {
                                testFilters[filterKey] = false;

                                if ($self.filters[filterKey].length > 0) {
                                    var formattedFilters = $self.filters[filterKey].map(function (filter) {
                                        return $self.handleize(filter);
                                    });
                                    var _formattedFilterData2 = product.filterData[filterKey] ? product.filterData[filterKey].map(function (tag) {
                                        return $self.handleize(tag);
                                    }) : null;

                                    if (filterKey != $self.shoesizeType) {
                                        if (_formattedFilterData2 && (_formattedFilterData2.filter(function (element) {
                                            return formattedFilters.includes(element);
                                        }).length > 0 || _formattedFilterData2.filter(function (element) {
                                            return filterTypeTags.includes(element);
                                        }).length > 0)) {
                                            testFilters[filterKey] = true;
                                        }
                                    } else {
                                        var _loop4 = function _loop4(j) {
                                            var splittedTag = $self.filters[filterKey][j].split($self.shoeSizeSeparator);
                                            var currentSizeMapping = $self.sizeMappingMetafield.find(function (sizeMapping) {
                                                return sizeMapping.id == parseInt(product.sizeMappingId);
                                            });

                                            if (currentSizeMapping && _formattedFilterData2) {

                                                var sizeMappingRows = currentSizeMapping.size.filter(function (size) {
                                                    var property = size[splittedTag[1]];
                                                    if (property !== undefined) {
                                                        return property.toString().toLowerCase() == splittedTag[0].toLowerCase();
                                                    }
                                                    return false;
                                                });

                                                if (sizeMappingRows.length > 0) {
                                                    for (var x = 0; x < sizeMappingRows.length; x++) {
                                                        var _iteratorNormalCompletion3 = true;
                                                        var _didIteratorError3 = false;
                                                        var _iteratorError3 = undefined;

                                                        try {
                                                            for (var _iterator3 = Object.entries(sizeMappingRows[x])[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                                                var _step3$value = _slicedToArray(_step3.value, 2),
                                                                    key = _step3$value[0],
                                                                    value = _step3$value[1];

                                                                if (key == splittedTag[1] && product.filterData[filterKey].includes(typeof value === 'string' ? value.toLowerCase() : value) || key == product.defaultSizeScale && product.filterData[filterKey].includes(typeof value === 'string' ? value.toLowerCase() : value)) {
                                                                    testFilters[filterKey] = true;
                                                                }
                                                            }
                                                        } catch (err) {
                                                            _didIteratorError3 = true;
                                                            _iteratorError3 = err;
                                                        } finally {
                                                            try {
                                                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                                                    _iterator3.return();
                                                                }
                                                            } finally {
                                                                if (_didIteratorError3) {
                                                                    throw _iteratorError3;
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            } else if (product.defaultSizeScale) {
                                                var defaultSizeScale = product.defaultSizeScale.toLowerCase();

                                                if (_formattedFilterData2 && defaultSizeScale == splittedTag[1] && _formattedFilterData2.includes($self.handleize(splittedTag[0]))) {
                                                    testFilters[filterKey] = true;
                                                }
                                            }
                                        };

                                        for (var j = 0; j < $self.filters[filterKey].length; j++) {
                                            _loop4(j);
                                        }
                                    }
                                } else {
                                    testFilters[filterKey] = true;
                                }
                            });

                            var formattedFilterData = product.filterData[initialFilterType] ? product.filterData[initialFilterType].map(function (tag) {
                                return $self.handleize(tag);
                            }) : null;

                            if (Object.keys(testFilters).filter(function (key) {
                                return testFilters[key] == true;
                            }).length == Object.keys($self.filters).length && initialFilterType != $self.shoesizeType) {
                                var tags = formattedFilterData ? formattedFilterData.filter(function (element) {
                                    return filterTypeTags.includes(element);
                                }) : [];

                                tags.map(function (tag) {
                                    var index = $self.initialFiltersTag[initialFilterType].findIndex(function (initialFilterTag) {
                                        return $self.handleize(initialFilterTag.tag) == tag;
                                    });

                                    if (index >= 0) {
                                        $self.initialFiltersTag[initialFilterType][index].disabled = false;
                                    }
                                });
                            } else if (Object.keys(testFilters).filter(function (key) {
                                return testFilters[key] == true;
                            }).length == Object.keys($self.filters).length && formattedFilterData) {
                                if (product.sizeMappingId) {
                                    var _currentSizeMapping = $self.sizeMappingMetafield.find(function (sizeMapping) {
                                        return sizeMapping.id == parseInt(product.sizeMappingId);
                                    });

                                    if (_currentSizeMapping) {
                                        var _loop5 = function _loop5(j) {

                                            var sizeMappingRows = _currentSizeMapping.size.filter(function (size) {
                                                var defaultSizeScale = product.defaultSizeScale;
                                                if (defaultSizeScale && size[defaultSizeScale]) {
                                                    return $self.handleize(size[defaultSizeScale].toString().toLowerCase()) === formattedFilterData[j].toLowerCase();
                                                }
                                                return false; // Handle the case where defaultSizeScale or size[defaultSizeScale] is undefined or null.
                                            });

                                            if (sizeMappingRows) {
                                                for (var x = 0; x < sizeMappingRows.length; x++) {
                                                    var _iteratorNormalCompletion4 = true;
                                                    var _didIteratorError4 = false;
                                                    var _iteratorError4 = undefined;

                                                    try {
                                                        var _loop6 = function _loop6() {
                                                            var _step4$value = _slicedToArray(_step4.value, 2),
                                                                key = _step4$value[0],
                                                                value = _step4$value[1];

                                                            var sizeIndex = $self.sizeMapping[key] ? $self.sizeMapping[key].findIndex(function (size) {
                                                                return size.size ? size.size.toString().toLowerCase() == value.toString().toLowerCase() : false;
                                                            }) : -1;

                                                            if (sizeIndex >= 0 && $self.sizeMapping[key][sizeIndex]) {
                                                                $self.sizeMapping[key][sizeIndex].disabled = false;
                                                            }
                                                        };

                                                        for (var _iterator4 = Object.entries(sizeMappingRows[x])[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                                            _loop6();
                                                        }
                                                    } catch (err) {
                                                        _didIteratorError4 = true;
                                                        _iteratorError4 = err;
                                                    } finally {
                                                        try {
                                                            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                                                _iterator4.return();
                                                            }
                                                        } finally {
                                                            if (_didIteratorError4) {
                                                                throw _iteratorError4;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        };

                                        for (var j = 0; j < formattedFilterData.length; j++) {
                                            _loop5(j);
                                        }
                                    }
                                } else if (product.defaultSizeScale) {
                                    var defaultSizeScale = product.defaultSizeScale.toLowerCase();
                                    var _tags = formattedFilterData ? formattedFilterData.filter(function (element) {
                                        return filterTypeTags.includes(element);
                                    }) : [];

                                    _tags.map(function (tag) {
                                        var sizeIndex = $self.sizeMapping[defaultSizeScale] ? $self.sizeMapping[defaultSizeScale].findIndex(function (size) {
                                            return size.size ? $self.handleize(size.size.toString().toLowerCase()) == tag.toString().toLowerCase() : false;
                                        }) : -1;

                                        if (sizeIndex >= 0) {
                                            $self.sizeMapping[defaultSizeScale][sizeIndex].disabled = false;
                                        }
                                    });
                                }
                            }
                        };

                        for (var _iterator2 = Object.entries($self.initialFiltersTag)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            _loop3();
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                });
            } else {
                Object.keys(this.initialFiltersTag).map(function (initialFilterType) {
                    for (var i = 0; i < $self.initialFiltersTag[initialFilterType].length; i++) {
                        $self.initialFiltersTag[initialFilterType][i].disabled = false;
                    }
                });

                Object.keys(this.sizeMapping).map(function (key) {

                    for (var i = 0; i < $self.sizeMapping[key].length; i++) {
                        if ($self.sizeMapping[key][i].disabled) {
                            $self.sizeMapping[key][i].disabled = false;
                        }
                    }
                });

                this.firstFilterType = false;
            }
        }
    }, {
        key: 'updateFilterObject',
        value: function updateFilterObject(type, name) {
            var updateFromClick = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;


            // I filtri department e macroCategory sono monochoice
            if (type == SlamJam.filterSettings.categoryFilter.department || type == SlamJam.filterSettings.categoryFilter.macroCategory) {
                // Non faccio un push (come andrebbe fatto di default), ma un assegnazione, così da forzare il mono-choice
                if (this.filters[type].includes(name)) {
                    this.filters[type] = [];
                } else {
                    this.filters[type] = [name];
                }

                if (type == SlamJam.filterSettings.categoryFilter.department) {
                    this.filters[SlamJam.filterSettings.categoryFilter.microCategory] = [];
                    this.filters[SlamJam.filterSettings.categoryFilter.macroCategory] = [];
                } else {
                    this.filters[SlamJam.filterSettings.categoryFilter.microCategory] = [];
                }
            } else {
                if (this.filters[type].includes(name)) {
                    this.filters[type] = this.filters[type].filter(function (filterValue) {
                        return filterValue !== name;
                    });
                } else {
                    this.filters[type].push(name);
                }
            }

            if (updateFromClick) {
                if (type == SlamJam.filterSettings.categoryFilter.macroCategory && this.filters[type].length > 0) {
                    // Forzo l'apertura del filtro micro se le micro esistono
                    this.currentFilterType = SlamJam.filterSettings.categoryFilter.microCategory;
                }
            }

            // Aggiorno firstFilterType
            if (!this.firstFilterType) {
                this.firstFilterType = type;
                localStorage.setItem('filter-first', type);
            }
        }

        // Gestione del click di un filtro

    }, {
        key: 'handleFilterLinkClick',
        value: function handleFilterLinkClick(link) {
            var filterType = link.dataset.filterType + '';
            var filterValue = link.dataset.filterValue + '';

            // Resetto pagination, currentPage e filteredProducts
            this.currentPage = 1;
            this.pagination = 1;
            this.filteredProducts = [];

            // aggiorno l'oggetto dei filtri
            this.updateFilterObject(filterType, filterValue, true);

            // Aggiorno url
            this.updateQueryParams();

            // Eseguo logica filtri
            this.executeFilters();
        }
    }, {
        key: 'clearFilters',
        value: function clearFilters() {
            var $self = this;

            // Resetto pagination, currentPage e filteredProducts
            this.currentPage = parseInt(this.getUrlParameter('page')) ? this.currentPage = parseInt(this.getUrlParameter('page')) : 1;
            this.pagination = 1;

            this.filteredProducts = [];
            localStorage.setItem('filter-first', false);
            localStorage.setItem('filter-last', false);

            // Resetto i filtri
            Object.keys(this.filters).map(function (filterType) {
                $self.filters[filterType] = [];
            });

            // Aggiorno url
            this.updateQueryParams();

            // Eseguo logica filtri
            this.executeFilters();
        }

        // Conto i filtri attivi

    }, {
        key: 'countActiveFilters',
        value: function countActiveFilters() {
            var $self = this;

            return Object.keys(this.filters).reduce(function (filter, index) {
                return filter.concat($self.filters[index]);
            }, []).length;
        }
    }, {
        key: 'fetchPages',


        // Aggiungo i prodotti a frontend
        value: function fetchPages() {
            while (this.currentPage <= this.filterMaxPages + 1 && this.pages[this.currentPage]) {
                for (var i = 0; i < this.pages[this.currentPage].length; i++) {
                    this.filteredProducts.push(this.pages[this.currentPage][i]);
                }

                this.currentPage = this.currentPage + 1;
            }
        }

        // Se trovo il PID nell'url, riporto l'utente nella stessa posizione in cui si trovava prima di andare nella PDP

    }, {
        key: 'checkPid',
        value: function checkPid() {
            var pid = this.getUrlParameter('pid');

            if (pid) {
                var productCard = document.querySelectorAll('[data-product-id="' + pid + '"]')[0];

                if (productCard) {
                    setTimeout(function () {
                        var coordinate = productCard.getBoundingClientRect();

                        window.scrollTo(coordinate.x, Math.abs(coordinate.y) - 130);
                        document.getElementById('PageContainer').scrollTop = Math.abs(coordinate.y - 170);

                        // tolgo il pid una volta trovato il prodotto
                        /*
                            let queryString = window.location.search;
                            let urlParams = new URLSearchParams(queryString);
                            urlParams.delete('pid');
                            let baseUrl = window.location.href.split('?')[0];
                            let newUrl = baseUrl + '?' + urlParams.toString();
                             history.replaceState(null, null, newUrl);
                        */
                    }, 500);
                }
            }
        }

        // Gestisco la ricerca filtrando i brand a seconda del testo inserito nell'input del filtro brand

    }, {
        key: 'handleBrandSearch',
        value: function handleBrandSearch() {
            var brandFilterList = document.querySelectorAll('.filter-type--brand .filter-type__container .filter-type__list li');

            for (var i = 0; i < brandFilterList.length; i++) {
                var span = brandFilterList[i].getElementsByTagName('span')[0];
                if (span.innerHTML.toLowerCase().indexOf(this.searchBrand.toLowerCase()) > -1) {
                    brandFilterList[i].style.display = '';
                } else {
                    brandFilterList[i].style.display = 'none';
                }
            }
        }
        /**
         * Sort logic
         */

    }, {
        key: 'handleSortByOnChange',
        value: function handleSortByOnChange() {
            var sortByElement = document.querySelector(this.sortBySelector);

            this.sorting = sortByElement.value;

            this.sortProducts();

            // Resetto pagination, currentPage e filteredProducts
            this.currentPage = parseInt(this.getUrlParameter('page')) ? this.currentPage = parseInt(this.getUrlParameter('page')) : 1;
            this.pagination = 1;
            this.filteredProducts = [];

            // Aggiorno url
            this.updateQueryParams();

            // esecuizione della logica di filtraggio
            this.executeFilters();
        }
    }, {
        key: 'sortFilters',
        value: function sortFilters() {
            var $self = this;

            var clothingSizesArray = [];
            var clothingSizesGrouped = {};

            var accessorySizesArray = [];
            var accessorySizesGrouped = {};
            var notMapped = []; // Array delle taglie trovate nei tag, ma non mappate nel customize. Le taglie non mappate vengono stampate dopo tutte le altre mappate

            // Gestione separazione filtri abbigliamento. Splitto per '|' e prendo tutte le scale taglie mappate per l'abbigliamento inserite nel customize
            var rangesClothing = $self.sizesRangeClothing.split('|');

            // Per ogni scala taglia, mi salvo tutte le singole taglie. Ci fornirà anche l'ordinamento da mostrare a frontend
            rangesClothing.forEach(function (rangeClothing) {
                var limits = rangeClothing.split(',');

                clothingSizesArray.push(limits);
            });

            // Gestione separazione filtri accessori. Splitto per '|' e prendo tutte le scale taglie mappate per gli accessori inserite nel customize
            var rangesAccessory = $self.sizesRangeAccessory.split('|');

            // Per ogni scala taglia, mi salvo tutte le singole taglie. Ci fornirà anche l'ordinamento da mostrare a frontend
            rangesAccessory.forEach(function (rangeAccessory) {
                var limits = rangeAccessory.split(',');

                accessorySizesArray.push(limits);
            });

            // Mi ciclo tutti le tipologie di filtri
            Object.keys(this.initialFiltersTag).map(function (initialFilterType) {
                notMapped = [];

                if (initialFilterType == $self.clothingsizeType) {
                    // Creo un raggruppamento per scala taglia di tutte le taglie mappate
                    clothingSizesArray.forEach(function (clothingSizeArray, index) {
                        clothingSizesGrouped[index] = [];

                        clothingSizeArray.forEach(function (clothingSize) {
                            // Se trovo la taglia nei tag dei prodotti, associo alla taglia un gruppo (che mi servirà per capire quando mostrare la linea di separazione per le scale taglia a frontend)
                            var item = $self.initialFiltersTag[initialFilterType].find(function (initialFilter) {
                                return initialFilter.tag.toLowerCase() == clothingSize.toLowerCase();
                            });

                            if (item) {
                                item.group = index;
                                clothingSizesGrouped[index].push(item);
                            }
                        });
                    });

                    // Cerco le taglie non mappate, considerando i tag dei prodotti e il raggruppamento appena creato.
                    // Quindi se non trovo una delle taglie che sono nei filtri nel raggruppamento, è non mappata.
                    $self.initialFiltersTag[initialFilterType].forEach(function (initialClothingSize) {
                        var found = false;

                        Object.keys(clothingSizesGrouped).map(function (index) {
                            // Evito di mettere più volte la stessa taglia non mappata
                            if (clothingSizesGrouped[index].findIndex(function (clothingSizeGrouped) {
                                return clothingSizeGrouped.tag.toLowerCase() == initialClothingSize.tag.toLowerCase();
                            }) >= 0 && notMapped.findIndex(function (notMappedItem) {
                                return notMappedItem.tag.toLowerCase() == initialClothingSize.tag.toLowerCase();
                            }) == -1) {
                                found = true;
                            }
                        });

                        if (!found) {
                            initialClothingSize.group = 'not-mapped';
                            notMapped.push(initialClothingSize);
                        }
                    });

                    $self.initialFiltersTag[initialFilterType] = [];

                    // Il raggruppamento è concluso e ora posso mettere nei tag iniziali le taglie ordinate dopo il raggruppamento
                    Object.keys(clothingSizesGrouped).map(function (index) {
                        $self.initialFiltersTag[initialFilterType] = $self.initialFiltersTag[initialFilterType].concat(clothingSizesGrouped[index]);
                    });

                    // E in fondo allego le taglie non mappate
                    $self.initialFiltersTag[initialFilterType] = $self.initialFiltersTag[initialFilterType].concat(notMapped);
                } else if (initialFilterType == $self.accessorysizeType) {
                    // Vedere il funzionamento per l'ordinamento delle taglie calzature
                    accessorySizesArray.forEach(function (accessorySizeArray, index) {
                        accessorySizesGrouped[index] = [];

                        accessorySizeArray.forEach(function (accessorySize) {
                            var item = $self.initialFiltersTag[initialFilterType].find(function (initialFilter) {
                                return initialFilter.tag.toLowerCase() == accessorySize.toLowerCase();
                            });

                            if (item) {
                                item.group = index;
                                accessorySizesGrouped[index].push(item);
                            }
                        });
                    });

                    $self.initialFiltersTag[initialFilterType].forEach(function (initialAccessorySize) {
                        var found = false;

                        Object.keys(accessorySizesGrouped).map(function (index) {
                            if (accessorySizesGrouped[index].findIndex(function (accessorySizeGrouped) {
                                return accessorySizeGrouped.tag.toLowerCase() == initialAccessorySize.tag.toLowerCase();
                            }) >= 0 && notMapped.findIndex(function (notMappedItem) {
                                return notMappedItem.tag.toLowerCase() == initialAccessorySize.tag.toLowerCase();
                            }) == -1) {
                                found = true;
                            }
                        });

                        if (!found) {
                            initialAccessorySize.group = 'not-mapped';
                            notMapped.push(initialAccessorySize);
                        }
                    });

                    $self.initialFiltersTag[initialFilterType] = [];

                    Object.keys(accessorySizesGrouped).map(function (index) {
                        $self.initialFiltersTag[initialFilterType] = $self.initialFiltersTag[initialFilterType].concat(accessorySizesGrouped[index]);
                    });

                    $self.initialFiltersTag[initialFilterType] = $self.initialFiltersTag[initialFilterType].concat(notMapped);
                } else {
                    // Di default, l'ordinamento a frontend dei tag è alfabetico

                    /* OLD
                    $self.initialFiltersTag[initialFilterType].sort(function(a, b) {
                        let returnValue = 0;
                        const textA = a.tag.toUpperCase();
                        const textB = b.tag.toUpperCase();
                         returnValue = (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                         return returnValue;
                    });
                    */

                    $self.initialFiltersTag[initialFilterType].sort(function (a, b) {

                        var digitRegex = /^\d/;
                        var alphabetRegex = /^[a-zA-Z]/;
                        var symbolRegex = /^[^\w\s]/;

                        var scoreA = symbolRegex.test(a.tag) * 1 || digitRegex.test(a.tag) * 10 || alphabetRegex.test(a.tag) * 100;
                        var scoreB = symbolRegex.test(b.tag) * 1 || digitRegex.test(b.tag) * 10 || alphabetRegex.test(b.tag) * 100;

                        if (scoreA !== scoreB) {
                            return scoreA - scoreB;
                        }

                        if (a.tag < b.tag) {
                            return -1;
                        } else if (a.tag > b.tag) {
                            return 1;
                        }

                        return 0;
                    });
                }
            });
        }

        // Sorting a frontend delle tipologie di filtro. Il cliente può definire l'ordinamento dal customize

    }, {
        key: 'sortHTMLFilters',
        value: function sortHTMLFilters(parent) {
            var filters = document.getElementsByClassName('filter-type');

            // converte nodelist ad array
            var array = [];

            for (var _i6 = 0; _i6 < filters.length; _i6++) {
                array[_i6] = filters[_i6];
            }

            // sorting
            array.sort(function (a, b) {
                return +a.getAttribute('data-sort') - +b.getAttribute('data-sort');
            });

            var output = '';

            for (var i = 0; i < array.length; i++) {
                output += array[i].outerHTML;
            }

            var sortedHTML = '<div class="filter-types">' + output + '</div>';
            parent.innerHTML = sortedHTML.replace(/(\r\n|\n|\r)/gm, '').replace(/\s\s+/g, ' ');
        }
    }, {
        key: 'sortProducts',
        value: function sortProducts() {
            var page = 1;

            switch (this.sorting) {
                case 'trending':
                    this.products.sort(function (a, b) {
                        var returnValue = 0;

                        returnValue = a.position - b.position;

                        return returnValue;
                    });
                    break;

                case 'price-ascending':
                    // Sorting per price asc
                    this.products.sort(function (a, b) {
                        var returnValue = 0;

                        returnValue = a.price - b.price;

                        if (returnValue == 0) {
                            // If same date sort by title ascending
                            var textA = a.handle;
                            var textB = b.handle;

                            returnValue = textA < textB ? -1 : textA > textB ? 1 : 0;
                        }

                        return returnValue;
                    });
                    break;

                case 'price-descending':
                    // Sorting per price desc
                    this.products.sort(function (a, b) {
                        var returnValue = 0;

                        returnValue = b.price - a.price;

                        if (returnValue == 0) {
                            // If same date sort by title ascending
                            var textA = a.handle;
                            var textB = b.handle;

                            returnValue = textA < textB ? -1 : textA > textB ? 1 : 0;
                        }

                        return returnValue;
                    });
                    break;

                case 'title-ascending':
                    // Sorting per title asc
                    this.products.sort(function (a, b) {
                        var returnValue = 0;
                        var textA = a.title.toUpperCase();
                        var textB = b.title.toUpperCase();

                        returnValue = textA < textB ? -1 : textA > textB ? 1 : 0;

                        return returnValue;
                    });
                    break;

                case 'title-descending':
                    // Sorting per title desc
                    this.products.sort(function (a, b) {
                        var returnValue = 0;
                        var textA = a.title.toUpperCase();
                        var textB = b.title.toUpperCase();

                        returnValue = textB < textA ? -1 : textB > textA ? 1 : 0;

                        return returnValue;
                    });
                    break;

                case 'created-descending':
                    // Sorting per date asc
                    this.products.sort(function (a, b) {
                        var returnValue = 0;
                        returnValue = b.date - a.date;
                        if (returnValue == 0) {
                            // If same date sort by title ascending
                            var textA = a.handle;
                            var textB = b.handle;

                            returnValue = textA < textB ? -1 : textA > textB ? 1 : 0;
                            // returnValue = b.position - a.position;
                        }

                        return returnValue;
                    });
                    break;
                case 'created-ascending':
                    // Sorting per date desc
                    this.products.sort(function (a, b) {

                        var returnValue = 0;
                        returnValue = a.date - b.date;

                        if (returnValue == 0) {
                            // If same date sort by title ascending
                            var textA = a.handle;
                            var textB = b.handle;

                            returnValue = textA < textB ? -1 : textA > textB ? 1 : 0;
                        }

                        return returnValue;
                    });
                    break;
            }

            // Dopo aver ordinato i prodotti (da codice) secondo un determinato sorting, creo le pagine per il frontend con i prodotto ordinati

            this.pages = [];

            for (var i = 0; i < this.products.length; i++) {
                if (this.pages[page] != null) {
                    this.pages[page].push(this.products[i]);
                } else {
                    this.pages[page] = [];
                    this.pages[page].push(this.products[i]);
                }

                // Quando ho concluso di riempire una pagina con i prodotti, vado 'a pagina nuova'
                if ((i + 1) % this.perPage == 0) {
                    page += 1;
                }
            }
        }

        /**
         * Query params logic
         */

    }, {
        key: 'getUrlParameter',
        value: function getUrlParameter(param) {
            var queryString = window.location.search;
            var urlParams = new URLSearchParams(queryString);

            if (urlParams.get(param)) return urlParams.get(param);

            return false;
        }
    }, {
        key: 'updateQueryParams',
        value: function updateQueryParams() {
            var $self = this;

            var urlParams = [];

            // Aggiorno le query params dell'url
            var filtersQueryParams = Object.keys(this.filters).map(function (key) {
                if ($self.filters[key].length > 0) {
                    return $self.filterUrlPrefix + key + '=' + $self.filters[key].join(',');
                }
            }).filter(Boolean);

            urlParams = urlParams.concat(filtersQueryParams);

            // Aggiorno la query param della paginazione

            if (this.pagination > 1) {
                urlParams.push('pagination' + '=' + this.pagination);
            }

            if (this.getUrlParameter('page')) {
                urlParams.push('page' + '=' + this.getUrlParameter('page'));
            }

            if (this.pid) {
                urlParams.push('pid' + '=' + this.pid);
            }

            if (this.getUrlParameter('q')) {
                urlParams.push('q' + '=' + this.getUrlParameter('q'));
            }

            if (this.getUrlParameter('type')) {
                urlParams.push('type' + '=' + this.getUrlParameter('type'));
            }

            if (this.sorting) {
                urlParams.push('custom-sort-by' + '=' + this.sorting);
            }

            // Aggiorno query params nell'url
            history.replaceState(null, null, window.location.href.split('?')[0] + '?' + urlParams.join('&'));
        }

        /**
         * Event handler
         */

    }, {
        key: 'initEventHandlers',
        value: function initEventHandlers() {
            var $self = this;

            /*
            window.addEventListener('pageshow', function (e) {
                if(e.persisted) {
                    $self.dispatchEvent('onInitEnded');
                }
            });
            */

            // Fix for Safari bfcache (back-forward cache, round-trip cache)
            $self.dispatchEvent('onInitEnded');

            if (SlamJam.isSafariBrowser() == true) {
                window.addEventListener('pageshow', function (e) {
                    if (e.persisted) {
                        $self.dispatchEvent('onInitEnded');
                    }
                });
            } else {
                $self.dispatchEvent('onInitEnded');
            }

            // Quando l'init è concluso
            window.addEventListener(this.namespace + '-' + 'onInitEnded', function (event) {
                var showArticlesSelectors = document.querySelectorAll($self.showArticlesSelector);

                if (SlamJam.filterSettings.isSearch) {
                    if ($self.articles.length > 0) {
                        $self.printArticlesListing();

                        for (var i = 0; i < showArticlesSelectors.length; i++) {
                            showArticlesSelectors[i].style.display = 'block';
                        }
                    }
                }

                $self.checkPid();
            });

            document.addEventListener('click', function (event) {

                // Evento onClick di un titolo di un filtro
                if (event.target.matches($self.filterTypeTitleSelector)) {
                    event.preventDefault();
                    $self.handleFilterTitle(event.target);
                };

                // Evento onClick di un filtro
                if (event.target.matches($self.filterLinkSelector)) {
                    event.preventDefault();
                    event.target.classList.add('active');
                    $self.showLoader();
                    $('.filter-mobile__title--button span').text("done");

                    setTimeout(function () {
                        // mettere un setTimeout se si vuole mostrare per qualche millesimo di secondo il loader
                        $self.handleFilterLinkClick(event.target);
                    }, 800);
                }

                // Evento onClick del load-more
                if (event.target.matches($self.loadMoreSelector)) {
                    event.preventDefault();
                    $self.showLoader();
                    var timeout = void 0;

                    // $self.counter.replace(/$number_of_out_product/g, SlamJam.filters.lastProductPrinted);

                    if ($self.pagination <= $self.currentPage) {
                        $self.pagination = $self.pagination + 1;

                        $self.updateQueryParams();

                        /* if($self.getUrlParameter('pagination') >= 4) {
                            setTimeout(function () {
                                // mettere un setTimeout se si vuole mostrare per qualche millesimo di secondo il loader
                                $self.printProductsListing('load-more');
                                clearTimeout(timeout);
                            }, 800);
                        } else {
                            $self.printProductsListing('load-more');
                          } */
                        $self.printProductsListing('load-more');
                        $self.printCounter();

                        var printProductsEvent = new CustomEvent($self.namespace + '-printProductsEvent');
                        window.dispatchEvent(printProductsEvent);
                    }

                    //  $self.hideLoader();
                }

                // Evento onClick del clear all filters
                if (event.target.matches($self.clearFiltersSelector)) {
                    event.preventDefault();
                    $self.clearFilters();
                }
            }, false);

            document.addEventListener('change', function (event) {
                // Evento onChange della select per il sort
                if (event.target.matches($self.sortBySelector)) {
                    event.preventDefault();
                    $self.handleSortByOnChange();
                }
            }, false);

            document.addEventListener('click', function (event) {
                // Evento onClick switch view search
                if (event.target.matches($self.showProductsSelector)) {
                    event.preventDefault();

                    $self.handleHiglight('products');
                }

                if (event.target.matches($self.showArticlesSelector)) {
                    event.preventDefault();

                    $self.handleHiglight('articles');
                }
            }, false);
        }

        /**
         * Custom Events
         */

    }, {
        key: 'customInitEventHandlers',
        value: function customInitEventHandlers() {
            var $self = this;

            window.addEventListener(this.namespace + '-' + 'onInit', function (event) {
                $self.showLoader();
                $self.filtersCustomization();
            });

            // Quando l'init è concluso
            window.addEventListener(this.namespace + '-' + 'onInitEnded', function (event) {
                $self.hideLoader();
                $self.filtersCustomization();
            });

            window.addEventListener(this.namespace + '-' + 'onFiltersUpdating', function (event) {
                $self.showLoader();
                $self.filtersCustomization();
            });

            window.addEventListener(this.namespace + '-' + 'onProductsFetched', function (event) {
                // sorting dell'oggetto per il filtro category
                $self.filtersCategoryHierarchical = $self.sortObjKeysAlphabetically($self.filtersCategoryHierarchical);

                // init del size mapping
                $self.initSizeMapping();
                $self.filtersCustomization();
            });

            // Quando devo aggiornare l'html dei filtri e dei prodotti
            window.addEventListener(this.namespace + '-' + 'onFiltersUpdated', function (event) {
                $self.printProductsListing('reset');
                $self.printCurrentFilters();
                $self.printFilters();
                $self.printTotalProducts();
                $self.hideLoader();
                //$self.handleStickyFilters();
                $self.filtersCustomization();
            });

            // Quando clicco sulla product card di un prodotto
            document.body.addEventListener('click', function (event) {
                var productCardElements = document.querySelectorAll($self.productCardSelector);

                productCardElements.forEach(function (element, index) {
                    if (element.contains(event.target)) {

                        var queryString = window.location.search;
                        var baseUrl = window.location.href.split('?')[0];
                        var urlParams = new URLSearchParams(queryString);

                        // Se trovo l'id del prodotto, lo salvo prima di andare alla scheda prodotto così posso riportare l'utente nella stessa posizione in cui si trovava prima di andare nella PDP
                        $self.pid = event.target.closest($self.productCardSelector).dataset.productId ? event.target.closest($self.productCardSelector).dataset.productId : false;

                        if ($self.pid) {
                            if (urlParams.has('pid')) {
                                urlParams.delete('pid');
                            }

                            urlParams.append('pid', $self.pid);

                            var newUrl = baseUrl + '?' + urlParams.toString();

                            history.replaceState(null, null, newUrl);
                        }
                    }
                });
            }, false);

            // Size mapping events
            document.addEventListener('click', function (event) {
                var filterWrapperElement = null;

                if (SlamJam.isMobile(1200)) {
                    filterWrapperElement = document.querySelector($self.filterWrappersMobile);
                } else {
                    filterWrapperElement = document.querySelector($self.filterWrappers);
                }

                if (event.target.matches($self.sizeMappingFakeSelectSelectorTrigger)) {
                    event.preventDefault();

                    filterWrapperElement.classList.toggle($self.sizeMappingSelectOpenClass);
                } else {
                    filterWrapperElement.classList.remove($self.sizeMappingSelectOpenClass);
                }

                if (event.target.matches($self.sizeMappingFakeOptionSelector)) {
                    event.preventDefault();

                    var _value = event.target.dataset.value;
                    var sizeMappingSelectElement = document.querySelector($self.sizeMappingSelectSelector);

                    $self.selectedSizeMapping = _value;
                    sizeMappingSelectElement.value = _value;
                    sizeMappingSelectElement.dispatchEvent(new Event('change'));

                    filterWrapperElement.classList.remove($self.sizeMappingSelectOpenClass);

                    // quando cambio scala taglia, riporto lo scroll del div a 0 per comodità dell'utente
                    document.querySelectorAll('.filter-type__container.open .filter-type__list')[0].scrollTop = 0;

                    $self.printFilters();
                }
            }, false);

            // input box nel filtro brand, quando scrivi filtra i valori in base alla parola ricercata
            document.addEventListener('input', function (event) {
                if (event.target.matches($self.searchBrandSelector)) {
                    event.preventDefault();
                    $self.searchBrand = event.target.value;

                    $self.handleBrandSearch();
                }
            });
        }

        /**
         * Size mapping functions
         */

    }, {
        key: 'initSizeMapping',
        value: function initSizeMapping() {
            var _this3 = this;

            var $self = this;

            // calcolo l'oggetto sizeMapping considerando tutti i prodotti nella collection/search

            var _loop7 = function _loop7(i) {
                if (_this3.products[i].sizeMappingId) {
                    var currentMapping = _this3.sizeMappingMetafield.find(function (sizeMapping) {
                        return sizeMapping.id == parseInt(_this3.products[i].sizeMappingId);
                    });

                    // se effettivamente esiste il sizeMapping indicato nel tag, costruisco l'oggetto
                    if (currentMapping) {
                        (function () {
                            var currentSizeMapping = currentMapping.size;
                            var productDefaultSizeScale = _this3.products[i].defaultSizeScale ? _this3.products[i].defaultSizeScale : currentMapping.default_size_scale.toLowerCase();
                            var productShoeSizes = _this3.products[i].filterData[$self.shoesizeType] ? _this3.products[i].filterData[$self.shoesizeType] : [];

                            // Ora che so quali taglie calzature sono disponibili per il prodotto, aggiungo all'oggetto sizeMapping le taglie del prodotto mappate per ogni scala taglia

                            var _loop8 = function _loop8(j) {
                                // è possibile avere più corrispondenze nel mapping per la stessa taglia, quindi non posso usare find ma devo usare filter
                                var sizeMappingRow = currentSizeMapping.filter(function (size) {
                                    var sizeValue = size[productDefaultSizeScale];
                                    var shoeSize = productShoeSizes[j];

                                    // Check if sizeValue and shoeSize are defined before calling toString
                                    if (sizeValue !== undefined && shoeSize !== undefined) {
                                        return sizeValue.toString().toLowerCase() === shoeSize.toString().toLowerCase();
                                    }

                                    return false; // or handle this case as needed
                                });

                                if (sizeMappingRow.length > 0) {
                                    for (var x = 0; x < sizeMappingRow.length; x++) {
                                        var _iteratorNormalCompletion5 = true;
                                        var _didIteratorError5 = false;
                                        var _iteratorError5 = undefined;

                                        try {
                                            for (var _iterator5 = Object.entries(sizeMappingRow[x])[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                                                var _step5$value = _slicedToArray(_step5.value, 2),
                                                    _key = _step5$value[0],
                                                    _value2 = _step5$value[1];

                                                if (!_this3.sizeMapping[_key]) {
                                                    _this3.sizeMapping[_key] = [];
                                                }

                                                // Evito di pushare i doppioni
                                                if (!_this3.sizeMapping[_key].includes(_value2.toString())) {
                                                    _this3.sizeMapping[_key].push(_value2.toString());
                                                }
                                            }
                                        } catch (err) {
                                            _didIteratorError5 = true;
                                            _iteratorError5 = err;
                                        } finally {
                                            try {
                                                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                                    _iterator5.return();
                                                }
                                            } finally {
                                                if (_didIteratorError5) {
                                                    throw _iteratorError5;
                                                }
                                            }
                                        }
                                    }
                                }
                            };

                            for (var j = 0; j < productShoeSizes.length; j++) {
                                _loop8(j);
                            }
                        })();
                    }
                } else if (_this3.products[i].defaultSizeScale && _this3.products[i].filterData[_this3.shoesizeType]) {
                    var defaultSizeScale = _this3.products[i].defaultSizeScale.toLowerCase();

                    _this3.products[i].filterData[_this3.shoesizeType].map(function (filterTag, index) {
                        if (!$self.sizeMapping[defaultSizeScale]) {
                            $self.sizeMapping[defaultSizeScale] = [];
                        }

                        // Evito di pushare i doppioni
                        if (!$self.sizeMapping[defaultSizeScale].includes(filterTag.toString())) {
                            $self.sizeMapping[defaultSizeScale].push(filterTag.toString());
                        }
                    });
                }
            };

            for (var i = 0; i < this.products.length; i++) {
                _loop7(i);
            }

            // in questa fase devo ordinare l'oggetto sizeMapping seguendo le schiere taglie inserite nel customize
            var shoeSizesObject = {};
            var notMapped = {};

            //Gestione separazione filtri scarpe
            var rangesSize = $self.sizesRangeShoe.split('|');

            rangesSize.forEach(function (rangeSize) {
                // splitto per la stringa '=' per avere una referenza per ogni scala taglia.
                // Es: uk=1,1.5,2, splittando per '=' ho il riferimento alla scala taglia (uk) e alle taglie che la compongono (1,1.5,2).
                // in questo modo so come devo ordinare i filtri per ogni scala taglia
                // Purtroppo esistono calzature con taglie internazionali (XS,S,M etc...) e per gestirle si è pensato di aggiungere alla fine di ogni altra schiera, tutte le taglie internazionli presenti nella collection

                var rangesSizeSplitted = rangeSize.split('=');
                shoeSizesObject[rangesSizeSplitted[0]] = [];

                var limits = rangesSizeSplitted[1].split('&');
                var totalShoeScale = [];

                limits.forEach(function (shoeScale, index) {
                    var currentShoeScale = shoeScale.split(',');

                    currentShoeScale.forEach(function (shoeSize) {
                        var shoe = {};

                        shoe.size = shoeSize;
                        shoe.group = index;
                        shoe.disabled = false;

                        totalShoeScale.push(shoe);
                    });
                });

                shoeSizesObject[rangesSizeSplitted[0]] = totalShoeScale;
            });

            // effettivo ordinamento dell'oggetto sizeMapping secondo le schiere indicate nel customize. Segue in parte la logica dell'ordinamento di taglie abbigliamento e accessori
            Object.keys(this.sizeMapping).forEach(function (shoeSizeKey, index) {
                if (shoeSizesObject[shoeSizeKey]) {

                    // per prima cosa tolgo i filtri non mappati nelle schiera che sto analizzando e li metto in un array
                    var filteredSize = [];

                    $self.sizeMapping[shoeSizeKey].map(function (element, index) {
                        if (element) {
                            var size = shoeSizesObject[shoeSizeKey].find(function (size) {
                                return size.size.toLowerCase() == element.toLowerCase();
                            });

                            if (!size) {
                                if (!notMapped[shoeSizeKey]) {
                                    notMapped[shoeSizeKey] = [];
                                }

                                notMapped[shoeSizeKey].push({
                                    group: 'not-mapped',
                                    size: element,
                                    disabled: false
                                });

                                return false;
                            }

                            filteredSize.push(size);
                        }
                    });

                    $self.sizeMapping[shoeSizeKey] = filteredSize;

                    // ordinamento
                    $self.sizeMapping[shoeSizeKey].sort(function (a, b) {
                        return shoeSizesObject[shoeSizeKey].findIndex(function (size) {
                            return size.size == a.size;
                        }) - shoeSizesObject[shoeSizeKey].findIndex(function (size) {
                            return size.size == b.size;
                        });
                    });

                    // accodo alla schiera taglia attuale le taglie non mappate
                    if (notMapped[shoeSizeKey] && notMapped[shoeSizeKey].length > 0) {

                        $self.sizeMapping[shoeSizeKey] = $self.sizeMapping[shoeSizeKey].concat(notMapped[shoeSizeKey]);
                    }
                }
            });

            // controllo se ci sono taglie footwear nell'url e prendo l'ultima selezionata dall'utente, in modo tale da preselezionarne la scala taglia di riferimento nella select
            var filterSizeFootwear = this.getUrlParameter('filters-size-footwear');

            if (filterSizeFootwear) {
                var footwearSizes = filterSizeFootwear.split(',');
                var lastSize = '';

                if (Array.isArray(footwearSizes)) {
                    lastSize = footwearSizes.slice(-1)[0];
                } else {
                    lastSize = footwearSizes;
                }

                this.selectedSizeMapping = lastSize.split($self.shoeSizeSeparator)[1];
            }
        }

        /**
         * Customable render function
         */

    }, {
        key: 'printCounter',
        value: function printCounter() {
            document.querySelector(this.counter).style.display = 'flex';
            document.querySelector(this.counter).querySelector('.counter').innerText = SlamJam.filters.lastProductPrinted;
            document.querySelector(this.counter).querySelector('.total').innerText = SlamJam.filters.filteredProducts.length;
        }
    }, {
        key: 'printTotalProducts',
        value: function printTotalProducts() {
            var totalProductsElement = document.querySelector(this.totalProductsSelector);
            var totalProductsElementMobile = document.querySelector(this.totalProductsSelectorMobile);
            var count = SlamJam.strings.filters.general.products.replace('$count', this.filteredProducts.length);

            totalProductsElement.innerHTML = count;
            totalProductsElementMobile.innerHTML = count;

            this.printCounter();
        }
    }, {
        key: 'printProductsListing',
        value: function printProductsListing(printType) {
            // Controllo se ci sono troppi prodotti visualizzati. In caso ci fossero li nascondo
            var shift = this.filteredProducts.length - this.perPage * this.pagination > 0 ? this.filteredProducts.length - this.perPage * this.pagination : 0;
            var productListingElement = document.querySelector(this.productsListingSelector);
            var i = void 0;

            if (this.filteredProducts.length == 0) {
                // Gestione not found
                productListingElement.classList.add('empty');
                productListingElement.innerHTML = SlamJam.filterSettings.translations.noProducts;

                this.hideLoadMore();
            } else {
                // Se non sto usando il load more resetto l'html del div contenente i prodotti e resetto la variabile in cui mantengo l'indice dell'ultimo prodotto stampato
                if (printType != 'load-more') {
                    this.lastProductPrinted = 0;
                    productListingElement.innerHTML = '';
                }

                productListingElement.classList.remove('empty');

                var impressions = [];
                var criteoProducts = [];
                var productsToPrint = '';

                for (i = this.lastProductPrinted; i < this.filteredProducts.length - shift; i++) {

                    productsToPrint += this.filteredProducts[i].html;
                    // productListingElement.innerHTML += this.filteredProducts[i].html;

                    var impression = {
                        "item_id": this.filteredProducts[i].gtmProductId.toString(),
                        "item_name": this.filteredProducts[i].gtmProductTitle,
                        "item_brand": this.filteredProducts[i].gtmProductVendor.toString(),
                        "item_category2": this.filteredProducts[i].gtmProductCategory.toString(),
                        "item_category3": this.filteredProducts[i].productMicroCategory,
                        "price": this.filteredProducts[i].gtmProductPrice,
                        "index": this.filteredProducts[i].gtmProductPosition,
                        "item_size": this.filteredProducts[i].gtmProductVariant,
                        "item_category": this.filteredProducts[i].gtmDistribuition,
                        "item_sale": this.filteredProducts[i].gtmIsSale,
                        "item_gender": this.filteredProducts[i].gtmDimension5,
                        "item_availability": this.filteredProducts[i].gtmAvailability,
                        "affiliation": 'en_' + this.filteredProducts[i].gtmLocale,
                        "item_color": this.filteredProducts[i].gtmProductColor,
                        "item_style_code": this.filteredProducts[i].gtmSupplierCode,
                        "item_variant": this.filteredProducts[i].gtmBarcode
                    };

                    impressions.push(impression);
                    // Criteo
                    var crProd = this.filteredProducts[i].gtmProductId.toString();
                    criteoProducts.push(crProd);
                }

                productListingElement.innerHTML += productsToPrint;

                this.hideLoader();

                var gtmEventImpression = new CustomEvent("gtmEventImpression", { 'detail': impressions });
                document.dispatchEvent(gtmEventImpression);

                var gtmEventCriteoListing = new CustomEvent("gtmEventCriteoListing", { 'detail': criteoProducts });
                document.dispatchEvent(gtmEventCriteoListing);

                // Salvo indice dell'ultimo prodotto stampato
                this.lastProductPrinted = i;

                // Se sono arrivato all'ultima pagina, nascondo il load-more
                if (this.filteredProducts.length == this.filteredProducts.length - shift) {
                    this.hideLoadMore();
                } else {
                    this.showLoadMore();
                }

                // Ordinamento delle taglie nel product card
                SlamJam.sortSize('.product-card__size', '.product-card__sizes', '.product-card');

                // identify an element to observe
                var elementToObserve = document.querySelector("#shop-products");

                // create a new instance of `MutationObserver` named `observer`,
                // passing it a callback function
                var observer = new MutationObserver(function () {
                    setTimeout(function () {
                        // mettere un setTimeout se si vuole mostrare per qualche millesimo di secondo il loader
                        //$self.showLoader();
                        $('.loading-wrapper').css("display", "none");
                    }, 800);
                });

                // call `observe()` on that MutationObserver instance,
                // passing it the element to observe, and the options object
                observer.observe(elementToObserve, { childList: true });
            }
        }
    }, {
        key: 'printArticlesListing',
        value: function printArticlesListing() {
            var articlesMarkup = '<div class="blog__container">';

            this.articlesListing = document.querySelector(this.articlesListingSelector);

            for (var i = 0; i < this.articles.length; i++) {
                articlesMarkup += '<div class="blog__image-container">\n                <div class="blog__image">\n                    <a href="' + this.articles[i].url + '">\n\n                    <div class="ratio-container">\n                        <img alt="" src="' + this.articles[i].image + '">\n                    </div>\n\n                    <div class="blog__overlay">\n                        <a href="' + this.articles[i].url + '">\n                            <h1 class="blog__title">' + this.articles[i].title + '</h1>\n                        </a>\n                        ' + (this.articles[i].excerpt ? '<div class="blog__excerpt">' + this.articles[i].excerpt + '</div>' : '') + '\n                        <div class="blog__date">' + this.articles[i].date + '</div>\n                    </div>\n                </div>\n            </div>';
            }

            articlesMarkup += '</div>';

            this.articlesListing.innerHTML = articlesMarkup;
        }
    }, {
        key: 'printCurrentFilters',
        value: function printCurrentFilters() {
            var $self = this;
            var currentFiltersElement = void 0;
            var showCurrentFilters = false; // stampo i current filters solo se trovo altri filtri oltre a 'macro category' e 'department'

            if (SlamJam.isMobile(1200)) {
                currentFiltersElement = document.querySelector(this.currentFilterSelectorMobile);
            } else {
                currentFiltersElement = document.querySelector(this.currentFiltersSelector);
            }

            currentFiltersElement.innerHTML = '';

            if (this.countActiveFilters() > 0) {
                var currentFiltersMarkup = '';

                // Non stampo department e macroCategory come filtri perchè monochoice
                Object.keys(this.filters).map(function (filterType) {
                    if ( //filterType != SlamJam.filterSettings.categoryFilter.department &&
                    //filterType != SlamJam.filterSettings.categoryFilter.macroCategory &&
                    Object.keys($self.filters[filterType]).length > 0) {
                        var _loop9 = function _loop9(j) {
                            var filterLabel = '';

                            if ($self.filters[filterType] != 'yes') {
                                if (filterType == $self.shoesizeType) {
                                    var _splittedTag = $self.filters[filterType][j].split($self.shoeSizeSeparator);

                                    filterLabel = _splittedTag[0] + ' ' + _splittedTag[1];
                                } else {
                                    filterLabel = $self.initialFiltersTag[filterType].find(function (initialFilterTag) {
                                        return $self.handleize(initialFilterTag.tag) == $self.filters[filterType][j];
                                    }) ? $self.initialFiltersTag[filterType].find(function (initialFilterTag) {
                                        return $self.handleize(initialFilterTag.tag) == $self.filters[filterType][j];
                                    }).tag : $self.filters[filterType][j];
                                }
                            } else {
                                filterLabel = "Recycled";
                            }

                            currentFiltersMarkup = currentFiltersMarkup + ('<li class="filter-option" data-filter-type="' + filterType + '" data-filter-value="' + $self.filters[filterType][j] + '">') + ('<span class="current-filter">' + filterLabel + '</span></li>');
                        };

                        for (var j = 0; j < $self.filters[filterType].length; j++) {
                            _loop9(j);
                        }

                        showCurrentFilters = true;
                    }
                });

                if (showCurrentFilters) {
                    var clearFiltersMarkup = '<div class="current-filters__container">\n                    <div class="current-filters__bar">\n                        <div class="current-filters__selected">' + SlamJam.strings.filters.general.selected + '</div>\n                        <div class="current-filters__reset"><a id="clear-filters" href="javascript:void(0)">' + SlamJam.strings.filters.general.reset_filters + '</a></div>\n                    </div>\n                    <ul>' + currentFiltersMarkup + '</ul>\n                </div>';
                    var literalTemplate = clearFiltersMarkup;

                    currentFiltersElement.innerHTML = literalTemplate;
                }
            } else {
                if (SlamJam.isMobile(1200)) {
                    $('.filter-mobile__title--button span').text("filter");
                }
            }
        }
    }, {
        key: 'printFilters',
        value: function printFilters() {
            var $self = this;
            var filterWrapperElement = void 0;

            var filtersDeptSelected = $self.filters[SlamJam.filterSettings.categoryFilter.department];
            var fitlersMacroSelected = $self.filters[SlamJam.filterSettings.categoryFilter.macroCategory];

            if (SlamJam.isMobile(1200)) {
                filterWrapperElement = document.querySelector(this.filterWrappersMobile);
            } else {
                filterWrapperElement = document.querySelector(this.filterWrappers);
            }

            // serve per mantenere lo scroll effettuato dentro alla dropdown attiva ad ogni aggiornamento dell'html dei filtri
            var scrollTopOpened = document.querySelectorAll('.filter-type__container.open .filter-type__list').length > 0 ? document.querySelectorAll('.filter-type__container.open .filter-type__list')[0].scrollTop : null;

            filterWrapperElement.innerHTML = '';

            var filterWrapperElementMarkup = '';

            Object.keys(this.initialFiltersTag).map(function (initialFilterType) {
                var label = $self.initialFilters.find(function (initialFilter) {
                    return initialFilter.type == initialFilterType;
                }) ? $self.initialFilters.find(function (initialFilter) {
                    return initialFilter.type == initialFilterType;
                }).label : '';
                var type = $self.initialFilters.find(function (initialFilter) {
                    return initialFilter.type == initialFilterType;
                }) ? $self.initialFilters.find(function (initialFilter) {
                    return initialFilter.type == initialFilterType;
                }).type : '';
                var position = $self.initialFilters.find(function (initialFilter) {
                    return initialFilter.type == initialFilterType;
                }) ? $self.initialFilters.find(function (initialFilter) {
                    return initialFilter.type == initialFilterType;
                }).position : '';

                /**
                 * Il filtro category è un filtro complesso ed ha una logica molto particolare:
                 *
                 * Department e macro category sono filtri monochoice.
                 * Se ho selezionato un filtro macro category, creo a frontend un filtro con label il nome della macro category e come filtri tutte le micro category.
                 * Se entro in una collection che ha solo una micro category, il filtro category e il filtro per la micro non deve essere visualizzato.
                 * Se entro in una collection che ha solo una macro category, il filtro category non viene visualizzato, ma il filtro micro si.
                 * Se entro in una collection che ha solo un department, il filtro category viene visualizzato con le macro già esplose.
                 *
                 **/

                if (initialFilterType == 'category') {
                    (function () {
                        var department = '';
                        var macroCategory = '';
                        var titleType = 'Type';
                        var showCategoryFilter = true;
                        var hideParentFilter = false;

                        if (filtersDeptSelected.length > 0) {
                            department = Object.keys($self.filtersCategoryHierarchical).find(function (department) {
                                return $self.handleize(department) == filtersDeptSelected[0];
                            }); // caso con possibilità di filtro su department
                        } else if (Object.keys($self.filtersCategoryHierarchical).length == 1) {
                            department = Object.keys($self.filtersCategoryHierarchical)[0]; // caso senza possibilità di filtro su department (collection create con tag macro)
                        }

                        if (department) {
                            if (fitlersMacroSelected.length > 0) {
                                macroCategory = Object.keys($self.filtersCategoryHierarchical[department]).find(function (macroCategory) {
                                    return $self.handleize(macroCategory) == fitlersMacroSelected[0];
                                }); // caso con possibilità di filtro su macro
                            } else if (Object.keys($self.filtersCategoryHierarchical).length == 1 && Object.keys($self.filtersCategoryHierarchical[department]).length == 1) {
                                macroCategory = Object.keys($self.filtersCategoryHierarchical[department])[0]; // caso senza possibilità di filtro su macro (collection create con tag micro)
                            }
                        }

                        // Stampo il filtro 'category' solo se ho almeno più di due macro e un department
                        if (Object.keys($self.filtersCategoryHierarchical).length == 1 && Object.keys($self.filtersCategoryHierarchical[Object.keys($self.filtersCategoryHierarchical)[0]]).length == 1) {
                            showCategoryFilter = true;
                            hideParentFilter = true;
                        }

                        if (showCategoryFilter) {
                            filterWrapperElementMarkup += '<div class="filter-type filter-type--' + SlamJam.filterSettings.categoryFilter.department + ' ' + (fitlersMacroSelected.length > 0 || hideParentFilter ? ' disabled ' : '') + '" data-sort="' + position + '">';
                            var _label = $self.initialFilters.find(function (initialFilter) {
                                return initialFilter.type == initialFilterType;
                            }).label;

                            filterWrapperElementMarkup += '<div class="filter-type__title ' + (filtersDeptSelected.length > 0 ? ' active ' : '') + '" data-type="' + SlamJam.filterSettings.categoryFilter.department + '">' + _label + '</div>\n                        <div class="filter-type__container ' + (filtersDeptSelected.length > 0 || $self.currentFilterType === SlamJam.filterSettings.categoryFilter.department || $self.currentFilterType === SlamJam.filterSettings.categoryFilter.macroCategory || $self.currentFilterType === SlamJam.filterSettings.categoryFilter.microCategory && $self.filtersCategoryHierarchical[department] && $self.filtersCategoryHierarchical[department][macroCategory] && $self.filtersCategoryHierarchical[department][macroCategory].length <= 1 ? ' open ' : '') + '">\n                        <ul class="filter-type__list" data-scroll-lock-scrollable data-simplebar>';

                            Object.keys($self.filtersCategoryHierarchical).map(function (departmentLevel, i) {
                                // Il primo livello per il filtro 'category' è DEPARTMENT 
                                if (Object.keys($self.filtersCategoryHierarchical).length > 1) {
                                    filterWrapperElementMarkup = filterWrapperElementMarkup + ('<li class="filter-option ' + (SlamJam.filters.initialFiltersTag.dept[i].disabled ? ' unavailable ' : '') + ' first-level category-filter ' + (filtersDeptSelected.length > 0 && filtersDeptSelected.indexOf($self.handleize(departmentLevel)) == -1 ? ' unavailable ' : '') + '\n                                ' + (Object.keys($self.filtersCategoryHierarchical[departmentLevel]).length > 0 ? ' has-submenu ' : '') + '\n                                ' + ($self.findInObjectValuesArray($self.filters, $self.handleize(departmentLevel)) ? ' active ' : '') + '"\n                                data-filter-type="' + SlamJam.filterSettings.categoryFilter.department + '"\n                                data-filter-value="' + $self.handleize(departmentLevel) + '"\n                                data-type="' + SlamJam.filterSettings.categoryFilter.department + '"><span class="category-filter-span">' + departmentLevel + '</span>');
                                    filterWrapperElementMarkup = filterWrapperElementMarkup + '<ul class="category">';
                                }
                                var currentMacroCategory = false;

                                // Il secondo livello per il filtro 'category' è MACRO CATEGORY
                                Object.keys($self.filtersCategoryHierarchical[departmentLevel]).map(function (macroCategoryLevel, j) {
                                    currentMacroCategory = SlamJam.filters.initialFiltersTag["macro-category"].filter(function (name) {
                                        return name.tag.includes(macroCategoryLevel);
                                    });

                                    filterWrapperElementMarkup = filterWrapperElementMarkup + ('<li class="filter-option ' + (currentMacroCategory[0].disabled ? ' unavailable ' : '') + '\n                            second-level category-filter \n                                ' + ($self.findInObjectValuesArray($self.filters, $self.handleize(macroCategoryLevel)) ? ' active ' : '') + '"\n                                data-filter-value="' + $self.handleize(macroCategoryLevel) + '"\n                                data-type="' + SlamJam.filterSettings.categoryFilter.macroCategory + '"\n                                data-filter-type="' + SlamJam.filterSettings.categoryFilter.macroCategory + '">\n                                <span class="category-filter-span">' + macroCategoryLevel + '</span>\n                            </li>');
                                });

                                filterWrapperElementMarkup += '</ul></li>';
                            });

                            filterWrapperElementMarkup += '</ul></div></div>';
                        }

                        // Gestione per il filtro per le micro category
                        if (department && macroCategory && $self.filtersCategoryHierarchical[department][macroCategory].length > 1) {
                            filterWrapperElementMarkup += '<div class="filter-type filter-type--' + SlamJam.filterSettings.categoryFilter.microCategory + '" data-sort="' + position + '">';

                            filterWrapperElementMarkup += '<div class="filter-type__title" data-type="' + SlamJam.filterSettings.categoryFilter.microCategory + '">' + titleType + '</div>\n                        <div class="filter-type__container ' + ($self.currentFilterType === SlamJam.filterSettings.categoryFilter.microCategory ? ' open ' : '') + '">\n                        <ul class="filter-type__list" data-scroll-lock-scrollable data-simplebar>';

                            var _loop10 = function _loop10(i) {
                                // serve per capire se il filtro deve essere disabled
                                var filterTagMicro = $self.initialFiltersTag[SlamJam.filterSettings.categoryFilter.microCategory].find(function (tag) {
                                    return tag.tag == $self.filtersCategoryHierarchical[department][macroCategory][i];
                                });

                                filterWrapperElementMarkup = filterWrapperElementMarkup + ('<li>\n                            <span class="\n                                filter-option\n                                ' + (filterTagMicro && filterTagMicro.disabled ? ' disabled ' : '') + '\n                                ' + ($self.findInObjectValuesArray($self.filters, $self.handleize($self.filtersCategoryHierarchical[department][macroCategory][i])) ? ' active ' : '') + '"\n                                data-filter-value="' + $self.handleize($self.filtersCategoryHierarchical[department][macroCategory][i]) + '"\n                                data-type="' + SlamJam.filterSettings.categoryFilter.microCategory + '"\n                                data-filter-type="' + SlamJam.filterSettings.categoryFilter.microCategory + '"\n                            >\n                                    <span class="category-filter-span">' + $self.filtersCategoryHierarchical[department][macroCategory][i] + '</span>\n                                </span>\n                            </li>');
                            };

                            for (var i = 0; i < $self.filtersCategoryHierarchical[department][macroCategory].length; i++) {
                                _loop10(i);
                            }
                        }

                        filterWrapperElementMarkup += '</ul></div></div>';
                    })();
                } else if (initialFilterType == $self.shoesizeType) {
                    // Check filter visibility
                    var filtersEnabled = $self.initialFiltersTag[initialFilterType].filter(function (el) {
                        return el.disabled === false;
                    });

                    var disabled = filtersEnabled.length == 0 ? true : false;

                    if (Object.values($self.filters).length > 0) {
                        disabled = false;
                    }

                    if (filtersDeptSelected.length > 0) {
                        disabled = type == $self.shoesizeType && filtersDeptSelected.indexOf('footwear') == -1 ? true : false;
                    }

                    if ($self.initialFiltersTag[initialFilterType].length > 1 && Object.keys($self.sizeMapping).length > 0) {

                        filterWrapperElementMarkup += '<div class="filter-type filter-type--' + initialFilterType + ' ' + (disabled ? 'disabled' : '') + '" data-sort="' + position + '">';
                        filterWrapperElementMarkup += '<div class="filter-type__title" data-type="' + type + '">' + label + '</div>\n                        <div class="filter-type__container ' + ($self.currentFilterType === type ? ' open ' : '') + '">\n                        ';

                        // HTML per select reale del size mapping
                        var sizeMappingOptionsMarkup = '';

                        for (var i = 0; i < $self.sizeMappingOptions.length; i++) {

                            sizeMappingOptionsMarkup = sizeMappingOptionsMarkup + ('<option ' + ($self.selectedSizeMapping == $self.sizeMappingOptions[i].value ? 'selected="selected"' : '') + ' value="' + $self.sizeMappingOptions[i].value + '">' + $self.sizeMappingOptions[i].label + '</option>');
                        }

                        filterWrapperElementMarkup += '<select id="size-mapping">\n                        ' + sizeMappingOptionsMarkup + '\n                    </select>';

                        // HTML per select fake del size mapping
                        var sizeMappingFakeOptionsMarkup = '';
                        var sizeMappingSelectedOption = $self.sizeMappingOptions.find(function (sizeMappingOption) {
                            return sizeMappingOption.value == $self.selectedSizeMapping;
                        });

                        for (var _i7 = 0; _i7 < $self.sizeMappingOptions.length; _i7++) {

                            sizeMappingFakeOptionsMarkup = sizeMappingFakeOptionsMarkup + ('' + ($self.sizeMapping[$self.sizeMappingOptions[_i7].value] && $self.sizeMapping[$self.sizeMappingOptions[_i7].value].length > 0 ? '<div class="size-mapping-fake__option" data-value="' + $self.sizeMappingOptions[_i7].value + '">\n                                ' + $self.sizeMappingOptions[_i7].label + '\n                            </div>' : ''));
                        }

                        filterWrapperElementMarkup += '<div class="size-mapping-fake">\n                        <div class="size-mapping-fake__title">\n                            <div class="size-mapping-fake__title-wrapper">\n                                <span>\n                                    ' + sizeMappingSelectedOption.label + '\n                                </span>\n                                <div class="size-mapping-fake__icon"></div>\n                            </div>\n                        </div>\n                        <div class="size-mapping-fake__content">\n                            ' + sizeMappingFakeOptionsMarkup + '\n                        </div>\n                    </div>';

                        filterWrapperElementMarkup += '<ul class="filter-type__list" data-scroll-lock-scrollable data-simplebar>';

                        if ($self.sizeMapping[$self.selectedSizeMapping] && $self.sizeMapping[$self.selectedSizeMapping].length > 0) {
                            for (var _i8 = 0; _i8 < $self.sizeMapping[$self.selectedSizeMapping].length; _i8++) {

                                filterWrapperElementMarkup = filterWrapperElementMarkup + ('<li class="disabled-' + $self.sizeMapping[$self.selectedSizeMapping][_i8].disabled + '" data-grop="' + $self.sizeMapping[$self.selectedSizeMapping][_i8].group + '">\n                                <span class="filter-option\n                                    ' + ($self.sizeMapping[$self.selectedSizeMapping][_i8].disabled ? ' disabled ' : '') + '\n                                    ' + ($self.findInObjectValuesArray($self.filters, $self.sizeMapping[$self.selectedSizeMapping][_i8].size + '$' + $self.selectedSizeMapping) ? ' active ' : '') + '"\n                                    data-filter-value="' + $self.sizeMapping[$self.selectedSizeMapping][_i8].size + $self.shoeSizeSeparator + $self.selectedSizeMapping + '" data-type="' + type + '" data-filter-type="' + initialFilterType + '">\n                                    ' + $self.sizeMapping[$self.selectedSizeMapping][_i8].size + '\n                                </span>\n                            </li> \n\n                            ' + ($self.sizeMapping[$self.selectedSizeMapping][_i8] != undefined && _i8 + 1 < $self.sizeMapping[$self.selectedSizeMapping].length && $self.sizeMapping[$self.selectedSizeMapping][_i8].group != $self.sizeMapping[$self.selectedSizeMapping][_i8 + 1].group ? $self.sizeMapping[$self.selectedSizeMapping][_i8].disabled ? '' : '<li class="separator" data-grop="' + $self.sizeMapping[$self.selectedSizeMapping][_i8].group + '"></li>' : ''));
                            }
                        }

                        filterWrapperElementMarkup += '</ul></div></div>';
                    }
                } else if (initialFilterType != SlamJam.filterSettings.categoryFilter.microCategory && initialFilterType != SlamJam.filterSettings.categoryFilter.macroCategory && initialFilterType != SlamJam.filterSettings.categoryFilter.department) {
                    if ($self.initialFiltersTag[initialFilterType].length > 1) {
                        // @TODO: review category name (clothing, accessories) is static
                        var _filtersEnabled = $self.initialFiltersTag[initialFilterType].filter(function (el) {
                            return el.disabled === false;
                        });
                        var _disabled = _filtersEnabled.length == 0 ? true : false;
                        if (filtersDeptSelected.length > 0) {
                            _disabled = type == $self.clothingsizeType && filtersDeptSelected.indexOf('clothing') == -1 || type == $self.accessorysizeType && filtersDeptSelected.indexOf('accessories') == -1 ? true : false;
                        }
                        filterWrapperElementMarkup += '<div class="filter-type filter-type--' + initialFilterType + ' ' + (_disabled ? 'disabled' : '') + '" data-sort="' + position + '">';
                        filterWrapperElementMarkup += '<div class="filter-type__title" data-type="' + type + '">' + label + '</div>\n                        <div  class="filter-type__container ' + ($self.currentFilterType === type ? ' open ' : '') + '">\n                        ' + ($self.initialFilters.find(function (initialFilter) {
                            return initialFilter.type == initialFilterType;
                        }).showSearch ? '<input value="" class="filter-search" type="text" placeholder="Search" style=""></input>' : '') + '\n                        <ul class="filter-type__list" data-scroll-lock-scrollable data-simplebar>';
                        for (var _i9 = 0; _i9 < $self.initialFiltersTag[initialFilterType].length; _i9++) {

                            filterWrapperElementMarkup = filterWrapperElementMarkup + ('<li class="disabled-' + $self.initialFiltersTag[initialFilterType][_i9].disabled + '" data-grop="' + $self.initialFiltersTag[initialFilterType][_i9].group + '">\n                            <span class="\n                                filter-option\n                                ' + ($self.findInObjectValuesArray($self.filters, $self.handleize($self.initialFiltersTag[initialFilterType][_i9].tag)) ? ' active ' : '') + '\n                                ' + ($self.initialFiltersTag[initialFilterType][_i9].disabled ? ' disabled ' : '') + '"\n                                data-filter-value="' + $self.handleize($self.initialFiltersTag[initialFilterType][_i9].tag) + '" data-type="' + type + '" data-filter-type="' + initialFilterType + '">\n                                ' + $self.initialFiltersTag[initialFilterType][_i9].tag + '\n                            </span>\n                        </li>\n                        ' + ($self.initialFiltersTag[initialFilterType][_i9].group != undefined && _i9 + 1 < $self.initialFiltersTag[initialFilterType].length && $self.initialFiltersTag[initialFilterType][_i9].group != $self.initialFiltersTag[initialFilterType][_i9 + 1].group ? $self.initialFiltersTag[initialFilterType].disabled ? '' : '<li class="separator" data-grop="' + $self.initialFiltersTag[initialFilterType][_i9].group + '"></li>' : ''));
                        }

                        filterWrapperElementMarkup += '</ul></div></div>';
                    } else if (initialFilterType == 'recycled') {
                        if ($self.initialFiltersTag[initialFilterType][0].tag == 'yes') {
                            // @TODO: review category name (clothing, accessories) is static
                            var _filtersEnabled2 = $self.initialFiltersTag[initialFilterType].filter(function (el) {
                                return el.disabled === false;
                            });
                            var _disabled2 = _filtersEnabled2.length == 0 ? true : false;
                            if (filtersDeptSelected.length > 0) {
                                _disabled2 = type == $self.clothingsizeType && filtersDeptSelected.indexOf('clothing') == -1 || type == $self.accessorysizeType && filtersDeptSelected.indexOf('accessories') == -1 ? true : false;
                            }
                            filterWrapperElementMarkup += '<div class="filter-type filter-type--' + initialFilterType + ' ' + (_disabled2 ? 'disabled' : '') + '" data-sort="' + position + '">';
                            filterWrapperElementMarkup += '<div class="filter-type__title" data-type="' + type + '">' + label + '</div>\n                            <div  class="filter-type__container ' + ($self.currentFilterType === type ? ' open ' : '') + '">\n                            ' + ($self.initialFilters.find(function (initialFilter) {
                                return initialFilter.type == initialFilterType;
                            }).showSearch ? '<input value="" class="filter-search" type="text" placeholder="Search" style=""></input>' : '') + '\n                            <ul class="filter-type__list" data-scroll-lock-scrollable data-simplebar>';

                            for (var _i10 = 0; _i10 < $self.initialFiltersTag[initialFilterType].length; _i10++) {

                                filterWrapperElementMarkup = filterWrapperElementMarkup + ('<li>\n                                <span class="\n                                    filter-option\n                                    ' + ($self.findInObjectValuesArray($self.filters, $self.handleize($self.initialFiltersTag[initialFilterType][_i10].tag)) ? ' active ' : '') + '\n                                    ' + ($self.initialFiltersTag[initialFilterType][_i10].disabled ? ' disabled ' : '') + '"\n                                    data-filter-value="' + $self.handleize($self.initialFiltersTag[initialFilterType][_i10].tag) + '" data-type="' + type + '" data-filter-type="' + initialFilterType + '">\n                                        ' + $self.initialFiltersTag[initialFilterType][_i10].tag + '\n                                    </span>\n                                </li>\n                                ' + ($self.initialFiltersTag[initialFilterType][_i10].group != undefined && _i10 + 1 < $self.initialFiltersTag[initialFilterType].length && $self.initialFiltersTag[initialFilterType][_i10].group != $self.initialFiltersTag[initialFilterType][_i10 + 1].group ? $self.initialFiltersTag[initialFilterType][_i10].disabled ? '' : '<li class="separator ' + $self.initialFiltersTag[initialFilterType][_i10].group + '"></li>' : ''));
                            }

                            filterWrapperElementMarkup += '</ul></div></div>';
                        }
                    }
                }
            });

            var literalTemplate = '<div class="filter-types">' + filterWrapperElementMarkup + '</div>';

            filterWrapperElement.innerHTML = literalTemplate.replace(/(\r\n|\n|\r)/gm, '').replace(/\s\s+/g, ' ');

            // serve per mantenere la dropdown del filtro brand filtrata
            $self.handleBrandSearch();
            // serve per ordinare graficamente i filtri a seconda della posizione indicata nel customize
            $self.sortHTMLFilters(filterWrapperElement, scrollTopOpened);

            scrollTopOpened ? document.querySelectorAll('.filter-type__container.open .filter-type__list')[0].scrollTop = scrollTopOpened : null;
            $self.renderGenderFilter();
        }
    }, {
        key: 'hideLoadMore',
        value: function hideLoadMore() {
            var loadMoreElement = document.querySelector(this.loadMoreSelector);

            loadMoreElement.style.display = 'none';
        }
    }, {
        key: 'showLoadMore',
        value: function showLoadMore() {
            var loadMoreElement = document.querySelector(this.loadMoreSelector);

            loadMoreElement.style.display = 'flex';
        }
    }, {
        key: 'hideLoader',
        value: function hideLoader() {
            var loading = document.querySelector('[data-handle="generic-loading"]');
            var counter = document.querySelector('.collection-template__load-more');

            loading.style.display = 'none';
            counter.style.display = 'flex';
        }
    }, {
        key: 'showLoader',
        value: function showLoader() {
            var loading = document.querySelector('[data-handle="generic-loading"]');
            var counter = document.querySelector('.collection-template__load-more');

            loading.style.display = 'flex';
            counter.style.display = 'none';
        }

        // General functions

    }, {
        key: 'handleFilterTitle',
        value: function handleFilterTitle(target) {

            var filterType = target.dataset.type;
            var filterTypeElements = document.querySelectorAll(this.filterTypeSelector);

            for (var i = 0; i < filterTypeElements.length; i++) {
                if (filterTypeElements[i].children[0] != target) {
                    filterTypeElements[i].children[0].classList.remove('active');
                    filterTypeElements[i].children[1].classList.remove('open');
                }
            }

            if (target.parentNode.children[1].classList.contains('open')) {
                target.classList.remove('active');
                target.parentNode.children[1].classList.remove('open');
                this.currentFilterType = false;
            } else {
                target.classList.add('active');
                target.parentNode.children[1].classList.add('open');
                this.currentFilterType = filterType;
                new SimpleBar($('.filter-type__list'), { autoHide: false, forceVisible: true });
            }

            //  this.handleStickyFilters();
        }
    }, {
        key: 'handleHiglight',
        value: function handleHiglight(type) {
            var showArticlesSelectors = document.querySelectorAll(this.showArticlesSelector);
            var showProductsSelectors = document.querySelectorAll(this.showProductsSelector);
            var articlesListingContainer = document.querySelector(this.articlesListingContainerSelector);
            var productsListingContainer = document.querySelector(this.productsListingContainerSelector);
            var sortingSelectors = document.querySelectorAll(this.sortingSelector);

            if (type == 'products') {
                for (var i = 0; i < showArticlesSelectors.length; i++) {
                    showArticlesSelectors[i].classList.remove(this.activeClass);
                }

                for (var _i11 = 0; _i11 < showProductsSelectors.length; _i11++) {
                    showProductsSelectors[_i11].classList.add(this.activeClass);
                }

                productsListingContainer.classList.add(this.activeClass);
                articlesListingContainer.classList.remove(this.activeClass);

                for (var _i12 = 0; _i12 < sortingSelectors.length; _i12++) {
                    sortingSelectors[_i12].style.display = 'block';
                }
            } else {
                for (var _i13 = 0; _i13 < showArticlesSelectors.length; _i13++) {
                    showArticlesSelectors[_i13].classList.add(this.activeClass);
                }

                for (var _i14 = 0; _i14 < showProductsSelectors.length; _i14++) {
                    showProductsSelectors[_i14].classList.remove(this.activeClass);
                }

                articlesListingContainer.classList.add(this.activeClass);
                productsListingContainer.classList.remove(this.activeClass);

                for (var _i15 = 0; _i15 < sortingSelectors.length; _i15++) {
                    sortingSelectors[_i15].style.display = 'none';
                }
            }
        }
    }, {
        key: 'handleStickyFilters',
        value: function handleStickyFilters() {
            var desktopColumnFilters = document.querySelector('.filter-desktop');

            if (typeof desktopColumnFilters != 'undefined' && desktopColumnFilters != null) {
                // crea problemi con scroll dentro le dropdown dei filtri
                /*$('.filter-desktop').stick_in_parent({
                    'inner_scrolling': false,
                    'offset_top': 120
                });*/

                if (!window.sticky) {
                    window.sticky = new Sticky('.filter-desktop', {
                        marginTop: 110
                    });
                } else {
                    window.sticky.update();
                }
            }
        }
    }, {
        key: 'renderGenderFilter',
        value: function renderGenderFilter() {

            var men = false;
            var women = false;

            var arrayMan = [];
            var arrayWomen = [];

            for (var i = 0; i < SlamJam.filters.products.length; i++) {

                //  console.log(SlamJam.filters.products[i].gtmDimension5)
                if (SlamJam.filters.products[i].gtmDimension5 == 'men') {
                    men = true;
                    arrayMan.push(SlamJam.filters.products[i].productURL);
                } else if (SlamJam.filters.products[i].gtmDimension5 == 'women') {
                    women = true;

                    arrayWomen.push(SlamJam.filters.products[i].productURL);
                }
            }

            if (men == true && women == true) {
                document.querySelector('.filter-type--filter-gender').classList.add('visible');
            }
        }

        /* TODO: trasformare in vanilla JS */

    }, {
        key: 'filtersCustomization',
        value: function filtersCustomization() {

            //inserire all'interno sviluppi legati a funzionamenti già esistenti

            /* per tutti i tipo di filtri */
            $('.filter-types .filter-type').each(function () {
                //creo un array dove inserire dentro i gruppi di valore attivi
                var activeSeparator = [];

                // per ogni tipo mi ciclo ogni voce per beccare quella attiva
                $(this).find('.filter-type__list li').each(function () {
                    if ($(this).hasClass("disabled-false")) {
                        //se non sono disabilitate mi salvo il gruppo dove lasciare separatore
                        activeSeparator.push($(this).data("grop"));
                    }
                });

                // per ogni tipo di filtro mi ciclo i suoi relativi separatori
                $(this).find('.filter-type__list .separator').each(function () {
                    var currentSeparator = parseInt($(this).data("grop"));
                    // nascondo tutti i separatori
                    $(this).hide();

                    for (var i = 0; i < activeSeparator.length; i++) {
                        //se il separatore corrisponde al gruppo salvato precedentemente lo mostro
                        if (currentSeparator == activeSeparator[i]) {
                            $(this).css("display", "flex");
                        }
                    }
                });

                /* richiesta di Giacomo, se sizeguide produce 0 risultati
                nascondo voce footwear nei filtri */
                if ($(this).hasClass("filter-type--size-footwear")) {
                    var footwearFilterVoice = $(this);
                    var totalFootwearValues = $(this).find('.filter-type__list li').length;
                    var disabledFootwearValues = $(this).find('.filter-type__list li.disabled-true').length;

                    if (totalFootwearValues == disabledFootwearValues) {
                        $(footwearFilterVoice).hide();
                    }
                }
            });
        }
    }]);

    return Filters;
}();